<template>
  <div class="index" v-shortkey="['ctrl', 'alt', 'h']" @shortkey="theAction()">
    <div class="imagess">
      <div class="logo">
        <!-- <img src="../assets/logo.png" alt /> -->
      </div>
      <div class="nav_title">
        <!-- <img src="../assets/big_title.png" alt /> -->
      </div>
      <div class="nav nav_signup" v-if="isSignup" @click="navflage"></div>
      <!-- 申报结束 s -->
      <div class="nav nav_no_signup" v-else></div>
      <!-- 申报结束 s -->
      <div class="nav_arrow"></div>
      <!-- 活动简介 -->
      <div class="hdjj_title">
        <img src="../assets/活动简介.png" alt />
      </div>
      <div class="modle_wrap">
        <div class="hdjj-content">
          <p>为向全社会展示一批弘扬主旋律、传递正能量的优秀游戏产品和积极践行文化使命、履行社会责任的优秀游戏企业，树立产业示范标杆，由中国音像与数字出版协会主办，中国音数协游戏工委和中国音像与数字出版协会游戏产业研究专家委员会共同承办的2026年度“游戏行业精选案例征集”评审工作现正式面向全行业开启。本次征集活动将截止至2026年10月9日。作为中国游戏产业最具代表性、影响力、公信力的行业殊荣，本次“游戏行业精选案例征集”共有十个征集方向，涵盖企业、产品等方面。欢迎各单位踊跃参加。</p>
          <!-- <p>作为中国游戏产业最具代表性、影响力、公信力的行业殊荣，本次中国“游戏十强”共设置十个综合奖项及五个单项奖项，涵盖企业、产品、行业支持等方面。</p> -->
          <p v-if="false">本次征集活动将截止至9月24日。欢迎各单位踊跃参加。</p>
        </div>
      </div>
      <!-- 组织机构 --> 
      <div class="zzjg_title">
        <img src="../assets/组织机构.png" alt />
      </div>
      <div class="modle_wrap">
        <div class="zzjg-content">
          <p>主办：中国音像与数字出版协会</p>
          <p>承办：中国音数协游戏工委</p>
          <p><span style="visibility: hidden;">承办：</span>中国音数协游戏专委会</p>
        </div>
      </div>
      <!-- 征集方向 -->
      <div class="jxmc_title">
        <img src="../assets/征集方向.png" alt />
      </div>
      <div class="modle_wrap jxmc_wrap">
        <div class="jxmc-content">
          <Tabs :value="istabs" type="card">
            <TabPane label="企业方向" name="1">
              <div class="center">
                <p>2026年度精选游戏科技创新企业</p>
                <p>2026年度精选“走出去”游戏企业</p>
                <p>2026年度精选游戏研发团队</p>
                <p>2026年度精选游戏运营企业</p>
              </div>
            </TabPane>
            <TabPane label="产品方向" name="2">
              <div class="center">
                <p>2026年度精选移动游戏</p>
                <p>2026年度精选客户端游戏</p>
                <p>2026年度精选中华传统文化游戏</p>
                <p>2026年度精选游戏音乐设计</p>
                <p>2026年度精选游戏美术设计</p>
                <p>2026年度精选社会价值游戏</p>
              </div>
            </TabPane>
          </Tabs>
        </div>
      </div>
      <!-- 申报流程 -->
      <div class="hllj_title">
        <img src="../assets/申报流程.png" alt />
      </div>
      <div class="hllj_wrap">
        <div class="hllj-content">
          <ul>
            <li class="hllj_items" v-for="(item, index) in sblcList" :key="index" v-if="index < 4">
              <div class="item_img">
                <img :src="item.imgurl" alt="">
              </div>
              <div class="item_name">{{item.name}}</div>
              <div class="item_time">{{item.time}}</div>
            </li>
          </ul>
          <ul style="margin-top: 40px;">
            <li class="hllj_items" v-for="(item, index) in sblcList" :key="index" v-if="index >= 4">
              <div class="item_img">
                <img :src="item.imgurl" alt="">
              </div>
              <div class="item_name">{{item.name}}</div>
              <div class="item_time">{{item.time}}</div>
            </li>
          </ul>
        </div>
      </div>
      <!-- <div class="hllj">
        <img src="../assets/lj.png" alt />
      </div> -->
    </div>
    <div class="footer">
      <p>©2007-{{new Date().getFullYear()}} cgigc.com.cn All Rights Reserved.游戏产业网 版权所有</p>
      <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502033246">
        <p>京ICP备16008137号-5</p>
        <p><img src="../assets/ba.png" alt /> 京公网安备 11010502033246号</p>
      </a>
      <p>本次活动最终解释权归属中国音数协游戏工委</p>
    </div>

    <el-dialog
      :visible.sync="dialogVisible"
      width="1100px"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div class="dialog-title">{{isactive == 3?'申报预览':'申报信息填写'}}</div>
      <div class="dialog-content">
        <el-steps :active="isactive" finish-status="success" align-center v-if="isactive != 3">
          <el-step title="基本信息"></el-step>
          <el-step title="企业申报信息"></el-step>
          <el-step title="产品申报信息"></el-step>
          <el-step title="完成"></el-step>
        </el-steps>
        <!-- 表格区域 -->
        <div class="footer-active" v-if="isactive == 1 || isactive == 2" style="margin-top: 30px; border-bottom: 1px solid #f7f5f5; padding-bottom: 20px;">
          若无需申报{{isactive == 1?'企业':'产品'}}奖项可
          <span @click="tiaoguo">跳过</span>
          <p style="margin-top:10px;color:red">系统提交后内容将无法修改，请慎重填写。</p>
        </div>
        <!-- 基本信息 -->
        <div class="form" v-if="isactive != 3">
          <el-form
            v-if="isactive == 0"
            ref="formdata"
            :model="Entity"
            label-width="150px"
            :rules="rules"
            class="formdata"
          >
            <el-form-item label="企业名称" prop="CompanyName">
              <el-input v-model="Entity.CompanyName" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="联系人名称" prop="PeopleName">
              <el-input v-model="Entity.PeopleName" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="联系人手机号" prop="PeopleTel">
              <el-input v-model="Entity.PeopleTel" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="联系人邮箱" prop="PeopleEmail">
              <el-input v-model="Entity.PeopleEmail" size="mini"></el-input>
            </el-form-item>
            <div style="text-align:center">即将进入企业申报，如果只申报产品，申报时可点击跳过</div>
          </el-form>
          <!-- 企业申报信息 -->
          <div v-show="isactive == 1">
            <div>
              <div class="box" v-for="(item,index) in Entity.gameDeclareCompanyDeclares" :key="index">
                <div
                  class="title"
                  style="text-align: center;margin:20px 0;font-size:20px;font-weight: 600;"
                >
                  项目{{index == 0?'一':index == 1?'二':''}}
                  <i
                    class="el-icon-circle-close"
                    style="float:right;cursor:pointer"
                    v-if="index != 0"
                    @click="closeesc(index,'qiye')"
                  ></i>
                </div>
                <div class="box-content clearfix">
                  <el-form
                    :model="item"
                    :rules="rules2"
                    :ref="'ruledata'+index"
                    label-width="240px"
                    class="demo-ruleForm"
                  >
                    <el-form-item label="选择申报奖项" class="rider-class" prop="DeclareItem">
                      <el-select
                        v-model="item.DeclareItem"
                        placeholder="请选择申报奖项"
                        @change="cheselect(`ruledata${index}`,item.DeclareItem,index)"
                      >
                        <el-option
                          v-for="items in checklist2"
                          :key="items.value"
                          :label="items.value"
                          :value="items.value"
                          :disabled="items.disabled"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <div
                      class="sbjj"
                      v-for="items in checklist2"
                      :key="items.value"
                      v-html="items.html"
                      v-show="item.DeclareItem == items.value"
                    ></div>
                    <template v-if="item.DeclareItem">
                      <!-- <el-form-item
                        label="平台名称"
                        prop="PlateformName"
                        v-if="item.DeclareItem == '2026年度精选游戏运营企业'"
                      >
                        <el-input v-model="item.PlateformName" placeholder="请输入平台名称"></el-input>
                      </el-form-item> -->
                      <el-form-item
                        label="团队或工作室名称"
                        prop="JoinCompanyName"
                        v-if="item.DeclareItem == '2026年度精选游戏研发团队'"
                      >
                        <el-input v-model="item.JoinCompanyName" placeholder="请输入团队或工作室名称"></el-input>
                      </el-form-item>
                      <el-form-item
                        label="所属企业名称"
                        prop="BelongCompanyName"
                        v-if="item.DeclareItem == '2026年度精选游戏研发团队'"
                      >
                        <el-input v-model="item.BelongCompanyName" placeholder="请输入所属企业名称"></el-input>
                      </el-form-item>
                      <el-form-item
                        :label="item.DeclareItem == '2020年度中国游戏十强游戏产业支持'?'单位名称':'企业名称'"
                        prop="JoinCompanyName"
                        v-if="item.DeclareItem != '2026年度精选游戏研发团队'"
                      >
                        <el-input
                          v-model="item.JoinCompanyName"
                          :placeholder="item.DeclareItem == '2020年度中国游戏十强游戏产业支持'?'请输入单位名称':'请输入企业名称'"
                        ></el-input>
                      </el-form-item>
                      <el-form-item label="所属地区" prop="Province">
                        <provincecity
                          :provinceCode="item.Province"
                          :cityCode="item.Shi"
                          style="width:520px"
                          ref="addFormProvince"
                          @selectChange="(e,l)=>selectChange(e,l,index)"
                        ></provincecity>
                      </el-form-item>
                      <el-form-item label="人员数量" prop="PeopleNum">
                        <el-select v-model="item.PeopleNum" placeholder="请选择人员数量">
                          <el-option label="50人以下" value="50人以下"></el-option>
                          <el-option label="50人-100人" value="50人-100人"></el-option>
                          <el-option label="100人-500人" value="100人-500人"></el-option>
                          <el-option label="500人以上" value="500人以上"></el-option>
                        </el-select>
                      </el-form-item>

                      <el-form-item
                        :label="item.DeclareItem != '2026年度精选游戏研发团队'?'企业介绍':'团队或工作室介绍'"
                        prop="Introduction"
                        v-if="item.DeclareItem != '2020年度中国游戏十强游戏产业支持'"
                      >
                        <el-input
                          type="textarea"
                          :rows="2"
                          :maxlength="2500"
                          show-word-limit
                          resize="none"
                          class="textarea"
                          v-model="item.Introduction"
                          :placeholder="item.DeclareItem=='2026年度精选“走出去”游戏企业'?'主要介绍企业在海外游戏市场发展的规模和经营格局，以及在海外发行的产品名称和地区'
                          :item.DeclareItem=='2026年度精选游戏研发团队'?'主要介绍团队规模，核心成员简介以及研发成果'
                          :item.DeclareItem=='2026年度精选社会价值游戏'?'主要介绍企业在经营发展过程中履行的社会责任和义务，包括，防沉迷、环境保护、资源节约、促进就业、员工权益保护等方面'
                          :item.DeclareItem=='2026年度精选游戏科技创新企业'?'主要介绍企业在游戏技术方面的创新内容及应用情况':'企业介绍'"
                        ></el-input>
                      </el-form-item>
                      <!-- <el-form-item
                        label="平台网址"
                        prop="Website"
                        v-if="item.DeclareItem == '2026年度精选游戏运营企业'"
                      >
                        <el-input v-model="item.Website" placeholder="请填入平台首页网址"></el-input>
                      </el-form-item> -->
                      <el-form-item
                        label="单位/媒体介绍"
                        prop="Introduction"
                        v-if="item.DeclareItem == '2020年度中国游戏十强游戏产业支持'"
                      >
                        <el-input
                          type="textarea"
                          :rows="2"
                          :maxlength="2500"
                          show-word-limit
                          resize="none"
                          class="textarea"
                          v-model="item.Introduction"
                          placeholder="2500字以内"
                        ></el-input>
                      </el-form-item>
                      <el-form-item
                        class="custom_style"
                        label="通过益智、科普、教育、社交互动等玩法体现出游戏的功能性、教育性游戏出版物研发发行等方面有关的工作介绍"
                        prop="SocialResponsibility"
                        v-if="item.DeclareItem == '2026年度精选社会价值游戏'"
                      >
                        <el-input
                          type="textarea"
                          :rows="2"
                          :maxlength="10000"
                          show-word-limit
                          resize="none"
                          class="textarea textarea_work"
                          v-model="item.SocialResponsibility"
                          placeholder="不少于500字"
                        ></el-input>
                      </el-form-item>
                      <el-form-item
                        label="提供以上工作的照片或功能性、教育性游戏的视频或图片"
                        prop="TeamPhotoID"
                        class="picture-card custom_style"
                        v-if="item.DeclareItem == '2026年度精选社会价值游戏'"
                      >
                        <el-upload
                          :action="action"
                          list-type="picture-card"
                          :on-remove="(file,fileList)=>handleTeamPicRemove(file,fileList,'VoIType')"
                          :file-list="item.TeamPhotoID || []"
                          :on-success="(res,file,fileList)=>handleCompanySuccess(res,file,fileList,'VoIType')"
                          :before-upload="beforeCompanyUpload" 
                        >
                          <i class="el-icon-plus"></i>
                        </el-upload>
                        <span class="card"  style="display: block;line-height: 1.5;margin-top: 5px;">视频格式AVI、MOV、MP4，分辨率不低于1080P,照片或者图片4张，照片尺寸为1024X1024分辨率以上的高清图片，格式为JPEG或PNG (建议上传视频)。</span>
                      </el-form-item>
                      <!-- <el-form-item
                        label="参选企业全称"
                        prop="JoinCompanyName"
                        v-if="item.DeclareItem == '2026年度精选游戏运营企业'"
                      >
                        <el-input v-model="item.JoinCompanyName" placeholder="请输入参选企业全称"></el-input>
                      </el-form-item>-->
                      <el-form-item
                        label="主要产品名称"
                        prop="MainProductName"
                        v-if="item.DeclareItem == '2026年度精选“走出去”游戏企业'"
                      >
                        <el-input v-model="item.MainProductName" placeholder="请输入主要产品名称，多个产品名称用顿号隔开"></el-input>
                      </el-form-item>
                      <el-form-item
                        label="产品主要出口国家或地区"
                        prop="ProductExportCountry"
                        v-if="item.DeclareItem == '2026年度精选“走出去”游戏企业'"
                      >
                        <el-input
                          type="textarea"
                          :rows="2"
                          resize="none"
                          class="textarea"
                          v-model="item.ProductExportCountry"
                          placeholder="请输入产品主要出口国家或地区"
                        ></el-input>
                      </el-form-item>
                      <el-form-item
                        label="2026年在海外运营收入"
                        prop="ReceiveMoney"
                        v-if="item.DeclareItem == '2026年度精选“走出去”游戏企业'"
                      >
                        <el-input
                          type="textarea"
                          :rows="2"
                          resize="none"
                          class="textarea"
                          v-model="item.ReceiveMoney"
                          placeholder="每个产品海外收入分别标明，单位：万美元（ 请填写大致范围﹐该信息仅供评选参考使用）"
                        ></el-input>
                      </el-form-item>

                      <el-form-item
                        :label="item.DeclareItem == '2026年度精选游戏研发团队'?'参选团队或工作室LOGO':item.DeclareItem == '2020年度中国游戏十强游戏产业支持'?'参选单位LOGO':item.DeclareItem == '2026年度精选游戏运营企业'?'参选企业LOGO':'参选企业LOGO'"
                        prop="LogoID"
                      >
                        <div class="logo_upload_wrap">
                          <el-upload
                            class="avatar-uploader-logo"
                            :action="action"
                            :show-file-list="false"
                            :on-success="(res,file,fileList)=>handleAvatarSuccess(res,file,fileList,index,'qiye')"
                            :before-upload="beforeAvatarUploadThreeTypes"
                            :on-progress="(event, file, fileList)=>progressC(event, file, fileList,index,'qiye')"
                          >
                            <template v-if="item.LogoID && !item.isprogresszp">
                              <img v-if="item.LogoIDType == 'img'" :src="active+'?id='+item.LogoID" class="avatar"/>
                              <img v-else-if="item.LogoIDType == 'ai'" :src="require('../assets/ai.png')" class="avatar"/>
                              <img v-else-if="item.LogoIDType == 'psd'" :src="require('../assets/psd.png')" class="avatar"/>
                            </template>
                            <i
                              v-if="!item.LogoID && !item.isprogresszp"
                              class="el-icon-plus avatar-uploader-icon"
                            ></i>
                            <el-progress
                              type="circle"
                              v-if="item.isprogresszp"
                              :percentage="item.progressnumm"
                            ></el-progress>
                            <span>格式为 PNG 格式，LOGO背景透明，分辨率不低于2K<br>或者 ai 格式、或者 psd 格式，任选其一上传</span>
                          </el-upload>
                        </div>
                      </el-form-item>
                      <!-- <el-form-item
                        label="团队LOGO"
                        prop="ProductLogoID"
                        v-if="false"
                      >
                        <el-upload
                          class="avatar-uploader"
                          :action="action"
                          :show-file-list="false"
                          :on-success="(res)=>handleAvatarSuccess2(res,'ProductLogoID')"
                          :before-upload="beforeAvatarUpload"
                          :on-progress="progressD"
                        >
                          <img
                            v-if="item.ProductLogoID && !isprogressD"
                            :src="active+'?id='+item.ProductLogoID"
                            class="avatar"
                          />
                          <i
                            v-if="!item.ProductLogoID && !isprogressD"
                            class="el-icon-plus avatar-uploader-icon"
                          ></i>
                          <el-progress type="circle" v-if="isprogressD" :percentage="progressnummD"></el-progress>
                          <span>
                            请上传尺寸为256x256及以上的高清图标，格式要求为JPEG或PNG。
                          </span>
                        </el-upload>
                      </el-form-item> -->
                      <el-form-item
                        class="custom_style"
                        :label="item.DeclareItem == '2026年度精选游戏研发团队'?'所属企业营业执照复印件或者扫描件':item.DeclareItem == '2020年度中国游戏十强游戏产业支持'?'参选单位营业执照复印件或扫描件':item.DeclareItem == '2026年度精选游戏运营企业'?'参选企业营业执照复印件或者扫描件':'参选企业营业执照复印件或者扫描件'"
                        prop="ZZimgID"
                      >
                        <el-upload
                          class="avatar-uploader"
                          :action="action"
                          :show-file-list="false"
                          :on-success="(res,file,fileList)=>handleAvatarSuccess3(res,file,fileList,index,'qiye')"
                          :before-upload="beforeAvatarUpload1"
                          :on-progress="progressB"
                        >
                          <img
                            v-if="item.ZZimgID && !isprogress1"
                            :src="pdfimg?require('../assets/pdf.jpg'):active+'?id='+item.ZZimgID"
                            class="avatar"
                          />

                          <i
                            v-if="!item.ZZimgID && !isprogress1"
                            class="el-icon-plus avatar-uploader-icon"
                          ></i>
                          <el-progress type="circle" v-if="isprogress1" :percentage="progressnumm1"></el-progress>
                          <span> 请上传工商执照复印件盖章，格式为JPEG，PNG或PDF</span>
                        </el-upload>
                      </el-form-item>
                      <el-form-item
                        label="团队研发的产品名称"
                        prop="ProductExportCountry"
                        v-if="item.DeclareItem == '2026年度精选游戏研发团队'"
                      >
                        <el-input v-model="item.ProductExportCountry" placeholder="请输入团队研发的产品名称"></el-input>
                      </el-form-item>
                      
                      <el-form-item
                        class="picture-card"
                        label="团队照片"
                        prop="TeamPhotoID"
                        v-if="item.DeclareItem == '2026年度精选游戏研发团队'"
                      >
                        <el-upload
                          :action="action"
                          list-type="picture-card"
                          :on-remove="(file,fileList)=>handleRemove(file,fileList,index,'qiye')"
                          :file-list="item.TeamPhotoID || []"
                          :on-success="(res,file,fileList)=>handleAvatarSuccesslist(res,file,fileList,index,'qiye')"
                          :before-upload="(file)=>beforeAvatarUpload3(file,index,'qiye')"
                        >
                          <i class="el-icon-plus"></i>
                        </el-upload>
                        <span class="card" style="display: block;line-height: 1.5;margin-top: 5px;">展团队风采，最少三张，格式要求为JPEG或PNG, 不能低于3M</span>
                      </el-form-item>
                      <!-- <el-form-item
                        label="平台地址账号密码"
                        prop="PlateformInfo"
                        v-if="item.DeclareItem == '2026年度精选游戏运营企业'"
                      >
                        <el-input
                          type="textarea"
                          :rows="2"
                          :maxlength="300"
                          show-word-limit
                          resize="none"
                          class="textarea"
                          v-model="item.PlateformInfo"
                          placeholder="链接和至少两个测试账号密码"
                        ></el-input>
                      </el-form-item> -->
                      <!-- 新增游戏产品中新技术及应用的体现说明 sart -->
                      <el-form-item
                        :label="'游戏产品中新技术及应用的体现说明'"
                        prop="ProductExportCountry"
                        v-if="item.DeclareItem == '2026年度精选游戏科技创新企业' && false"
                      >
                        <el-input
                          type="textarea"
                          :rows="2"
                          :maxlength="2500"
                          show-word-limit
                          resize="none"
                          class="textarea"
                          v-model="item.ProductExportCountry"
                          :placeholder="'2500字以内，游戏产品中新技术及应用的体现说明'"
                        ></el-input>
                      </el-form-item>
                      <el-form-item
                          v-if="item.DeclareItem == '2026年度精选游戏科技创新企业'"
                          label="游戏产品中新技术及应用的体现说明视频"
                          prop="TeamPhotoID"
                          class="picture-card custom_style"
                        >
                          <el-upload
                            :action="action"
                            :limit="2"
                            list-type="picture-card"
                            :on-remove="(file,fileList)=>handleVideoRemovefilit(file,fileList,index,'qiye')"
                            :file-list="item.TeamPhotoID"
                            :on-success="(res,file,fileList)=>handleVideoSuccess(res,file,fileList,index,'qiye')"
                            :before-upload="beforeVideoUploadview" 
                          >
                            <i class="el-icon-plus"></i>
                          </el-upload>
                          <span class="card" style="display: block;line-height: 1.5;margin-top: 5px;">上下无遮挡，视频格式AVI、MOV、MP4，至多两个视频，不能低于1080P</span>
                        </el-form-item>
                        <el-form-item
                          label="技术专利证明"
                          v-if="item.DeclareItem == '2026年度精选游戏科技创新企业'"
                          prop=""
                        >
                          <el-upload
                            class="avatar-uploader"
                            :action="action"
                            :show-file-list="false"
                            :on-success="(res,file,fileList)=>handleAvatarSuccessA(res,file,fileList,index,'qiye')"
                            :before-upload="beforeAvatarUpload1"
                            :on-progress="progressE"
                          >
                            <img
                              v-if="item.PlateformInfo && !isprogressE"
                              :src="pdfimg?require('../assets/pdf.jpg'):active+'?id='+item.PlateformInfo"
                              class="avatar"
                            />

                            <i
                              v-if="!item.PlateformInfo && !isprogressE"
                              class="el-icon-plus avatar-uploader-icon"
                            ></i>
                            <el-progress type="circle" v-if="isprogressE" :percentage="progressnummE"></el-progress>
                            <span> 请上传技术专利证明，格式为JPEG、PNG或PDF</span>
                          </el-upload>
                        </el-form-item>
                        <el-form-item
                        label="举办运营活动的主要产品名称"
                        prop="BelongCompanyName"
                        v-if="item.DeclareItem == '2026年度精选游戏运营企业'"
                      >
                        <el-input v-model="item.BelongCompanyName" placeholder="请输入举办运营活动的主要产品名称"></el-input>
                      </el-form-item>
                      <el-form-item label="近一年围绕产品开展的运营工作介绍" prop="Website" v-if="item.DeclareItem== '2026年度精选游戏运营企业'">
                        <el-input
                          type="textarea"
                          :rows="2"
                          :maxlength="2500"
                          show-word-limit
                          resize="none"
                          class="textarea"
                          v-model="item.Website"
                          placeholder="包括但不限于产品运营模式、营销模式、运营活动(如IP联动、线下体验、展览展会等)等介绍"
                        ></el-input>
                      </el-form-item>
                      <el-form-item
                        class="picture-card"
                        label="运营活动宣传视频或图片"
                        prop="TeamPhotoID"
                        v-if="item.DeclareItem == '2026年度精选游戏运营企业'"
                      >
                        <el-upload
                          :action="action"
                          list-type="picture-card"
                          :on-remove="(file,fileList)=>handleRemove(file,fileList,index,'qiye')"
                          :file-list="item.TeamPhotoID || []"
                          :on-success="(res,file,fileList)=>handleAvatarSuccesslist(res,file,fileList,index,'qiye')"
                          :before-upload="(file)=>beforeAvatarUploadNew(file,index,'qiye')"
                        >
                          <i class="el-icon-plus"></i>
                        </el-upload>
                        <span class="card" style="display: block;line-height: 1.5;margin-top: 5px;">运营活动宣传视频或图片，最少三个视频或图片（视频格式AVI、MOV、MP4，不低于1080P；图片格式PNG、JPG，不低于3M）</span>
                      </el-form-item>
                        <!-- 新增游戏产品中新技术及应用的体现说明 end -->
                    </template>
                  </el-form>
                </div>
              </div>
              <div class="addform" @click="addform('qiye')" v-if="Entity.gameDeclareCompanyDeclares.length < 3">
                <img src="../assets/add.png" alt /> 继续填报
                <span>同一企业最多申报三个企业奖项</span>
              </div>
            </div>
          </div>
          <!-- 作品申报信息 -->
          <div v-show="isactive == 2">
            <div>
              <div class="box" v-for="(item,index) in Entity.GameDeclareWorkInfo" :key="index">
                <div
                  class="title"
                  style="text-align: center;margin:20px 0;font-size:20px;font-weight: 600;"
                >
                  项目{{index == 0?'一':index == 1?'二':index == 2?'三':''}}
                  <i
                    class="el-icon-circle-close"
                    style="float:right;cursor:pointer"
                    v-if="index != 0"
                    @click="closeesc(index,'chanpin')"
                  ></i>
                </div>
                <div class="box-content clearfix">
                  <el-form
                    :model="item"
                    :rules="rules1"
                    :ref="'ruleForm'+index"
                    label-width="240px"
                    class="demo-ruleForm"
                  >
                    <el-form-item label="选择申报奖项" class="rider-class" prop="DeclareItem">
                      <el-select
                        v-model="item.DeclareItem"
                        placeholder="请选择申报奖项"
                        @change="cheselect(`ruleForm${index}`,item.DeclareItem,index)"
                      >
                        <el-option
                          v-for="item in checklist1[0].options"
                          :key="item.value"
                          :label="item.value"
                          :value="item.value"
                          :disabled="item.disabled"
                        ></el-option>
                        <!-- <el-option-group
                          v-for="group in checklist1"
                          :key="group.label"
                          :label="group.label"
                        >
                        </el-option-group> -->
                      </el-select>
                    </el-form-item>
                    <div v-for="items in checklist1" :key="items.value">
                      <div
                        class="sbjj"
                        v-for="group in items.options"
                        :key="group.value"
                        v-html="group.html"
                        v-show="item.DeclareItem == group.value"
                      ></div>
                    </div>

                    <template v-if="item.DeclareItem">
                      <el-form-item
                        :label="'产品名称'"
                        prop="WorkName"
                      >
                        <el-input
                          v-model="item.WorkName"
                          :placeholder="'请输入产品名称'"
                        ></el-input>
                      </el-form-item>
                      <el-form-item label="版号(ISBN)" prop="Isbn">
                        <el-input
                          v-model="item.Isbn"
                          placeholder="如：978-7-498-08072-1（正规版号），格式为：xxx-x-xxx-xxxxx-x"
                        ></el-input>
                      </el-form-item>
                      <el-form-item label="产品介绍" prop="Introduction">
                        <el-input
                          type="textarea"
                          :rows="2"
                          :maxlength="2500"
                          show-word-limit
                          resize="none"
                          class="textarea"
                          v-model="item.Introduction"
                          :placeholder="item.DeclareItem == '2026年度精选移动游戏'?'请输入产品介绍，上线后的产品反响，获过哪些奖项':
                                        item.DeclareItem == '2026年度精选客户端游戏'?'请输入产品介绍，上线后的产品反响，获过哪些奖项':
                                        item.DeclareItem == '2026年度精选中华传统文化游戏'?'请输入产品介绍，简要介绍与中国传统文化有关的游戏内容、运营活动等，在中国传统文化传播方面有哪些作为':
                                        item.DeclareItem == '2026年度精选游戏音乐设计'?'请输入产品介绍，简要介绍音乐、音效等内容，获过哪些奖项':
                                        item.DeclareItem == '2026年度精选游戏美术设计'?'请输入产品介绍，简要介绍美术风格特点，获过哪些奖项':
                                        item.DeclareItem == '2026年度精选社会价值游戏'?'请输入产品介绍，简要介绍产品的社会功能，如何突出其社会价值':
                                        '请输入产品介绍'"
                        ></el-input>
                      </el-form-item>
                      <el-form-item
                        label="产品类型"
                        prop="WorkType"
                        v-if="item.DeclareItem != '2026年度精选移动游戏' && item.DeclareItem != '2026年度精选游戏运营企业'"
                      >
                        <el-select v-model="item.WorkType" placeholder="请选择产品类型">
                          <el-option
                            v-if="item.DeclareItem !='2026年度精选客户端游戏'"
                            label="移动游戏"
                            value="移动游戏"
                          ></el-option>
                          <el-option label="客户端游戏" value="客户端游戏"></el-option>
                          <el-option label="主机游戏" value="主机游戏"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item
                        label="团队名称"
                        prop="TeamName"
                        v-if="false"
                      >
                        <el-input v-model="item.TeamName" placeholder="请输入团队名称"></el-input>
                      </el-form-item>
                      <el-form-item label="上线时间" prop="InlineTime">
                        <el-date-picker
                          v-model="item.InlineTime"
                          value-format="yyyy-MM-dd"
                          type="date"
                          placeholder="选择日期"
                          :picker-options="pickerOptions" 
                        ></el-date-picker>
                      </el-form-item>
                      <el-form-item label="产品LOGO" prop="LogoID">
                        <div class="logo_upload_wrap">
                          <el-upload
                            class="avatar-uploader-logo"
                            :action="action"
                            :show-file-list="false"
                            :on-success="(res,file,fileList)=>handleAvatarSuccess(res,file,fileList,index)"
                            :before-upload="beforeAvatarUploadThreeTypes"
                            :on-progress="(event, file, fileList)=>progressC(event, file, fileList,index)"
                          >
                            <template v-if="item.LogoID && !item.isprogresszp">
                              <img v-if="item.LogoIDType == 'img'" :src="active+'?id='+item.LogoID" class="avatar"/>
                              <img v-else-if="item.LogoIDType == 'ai'" :src="require('../assets/ai.png')" class="avatar"/>
                              <img v-else-if="item.LogoIDType == 'psd'" :src="require('../assets/psd.png')" class="avatar"/>
                            </template>
                            <i
                              v-if="!item.LogoID && !item.isprogresszp"
                              class="el-icon-plus avatar-uploader-icon"
                            ></i>
                            <el-progress
                              type="circle"
                              v-if="item.isprogresszp"
                              :percentage="item.progressnumm"
                            ></el-progress>
                            <span>格式为 PNG 格式，LOGO背景透明，分辨率不低于2K<br>或者 ai 格式、或者 psd 格式，任选其一上传</span>
                          </el-upload>
                        </div>
                      </el-form-item>
                      <el-form-item
                        label="产品CG动画"
                        prop="CGID"
                      >
                        <el-upload
                          class="avatar-uploader"
                          :action="action"
                          :show-file-list="false"
                          :on-success="(res,file,fileList)=>handleAvatarSuccessview(res,file,fileList,index)"
                          :before-upload="beforeAvatarUploadview"
                          :on-progress="(event, file, fileList)=>uploadVideoProcess(event, file, fileList,index)"
                        >
                          <video
                            v-if="item.CGID && !item.isprogressview"
                            :src="active+'?id='+item.CGID"
                            class="avatar"
                          ></video>
                          <i
                            v-if="!item.CGID && !item.isprogressview"
                            class="el-icon-plus avatar-uploader-icon"
                          ></i>
                          <el-progress
                            type="circle"
                            v-if="item.isprogressview"
                            :percentage="item.progressnumm"
                          ></el-progress>
                          <span>{{item.DeclareItem == '2026年度精选游戏音乐设计' ? '参选游戏产品精彩CG动画最好包含游戏音乐' : '参选游戏产品精彩CG动画'}}，上下无遮挡，最好CG结尾以产品LOGO为最后的画面。视频格式AVI、MOV、MP4，不能低于1080P</span>
                        </el-upload>
                      </el-form-item>
                      <el-form-item
                        v-if="item.DeclareItem != '2026年度精选游戏美术设计' && item.DeclareItem != '2026年度精选游戏音乐设计'"
                        label="产品实机演示视频"
                        prop="FileID"
                        class="picture-card"
                      >
                        <el-upload
                          :action="action"
                          list-type="picture-card"
                          :limit="2"
                          :on-remove="(file,fileList)=>handleVideoRemovefilit(file,fileList,index)"
                          :file-list="item.FileID"
                          :on-success="(res,file,fileList)=>handleVideoSuccess(res,file,fileList,index)"
                          :before-upload="beforeVideoUploadview" 
                        >
                          <i class="el-icon-plus"></i>
                        </el-upload>
                        <span class="card"  style="display: block;line-height: 1.5;margin-top: 5px;">参选游戏产品体验片段，上下无遮挡，视频格式AVI、MOV、MP4，至多两个视频，不能低于1080P</span>
                      </el-form-item>
                      <el-form-item
                        label="产品截图"
                        prop="Images"
                        class="picture-card"
                        v-if="item.DeclareItem != '2026年度精选游戏音乐设计' && item.DeclareItem !='2020年度中国游戏十强优秀游戏原创剧情奖' && item.DeclareItem != '2020年度中国游戏十强优秀游戏动画表现奖'"
                      >
                        <el-upload
                          :action="action"
                          list-type="picture-card"
                          :on-remove="(file,fileList)=>handleRemove(file,fileList,index)"
                          :file-list="item.Images"
                          :on-success="(res,file,fileList)=>handleAvatarSuccesslist(res,file,fileList,index)"
                          :before-upload="(file)=>beforeAvatarUpload3(file,index)"
                        >
                          <i class="el-icon-plus"></i>
                        </el-upload>
                        <span class="card">至少上传4张图片，PNG、JPG格式，不能低于3M</span>
                      </el-form-item>
                      <el-form-item
                        class="custom_style"
                        label="游戏试玩下载地址及测试账户、密码"
                        prop="WokeInfo"
                      >
                        <el-input
                         :maxlength="2500"
                          show-word-limit
                          type="textarea"
                          :rows="2"
                          resize="none"
                          class="textarea"
                          v-model="item.WokeInfo"
                          placeholder="提供客户端下载链接和至少两个账户、密码，测试账户需要满级"
                        ></el-input>
                      </el-form-item>

                      <el-form-item
                        label="大致月活用户"
                        prop="UserPerMonth"
                        v-if="item.DeclareItem !='2026年度精选游戏运营企业' && item.DeclareItem !='2026年度精选社会价值游戏' && item.DeclareItem !='2026年度精选中华传统文化游戏' && item.DeclareItem !='2026年度精选游戏美术设计' && item.DeclareItem != '2026年度精选游戏音乐设计' && item.DeclareItem !='2020年度中国游戏十强优秀游戏原创剧情奖' && item.DeclareItem != '2020年度中国游戏十强优秀游戏动画表现奖'"
                      >
                        <el-input
                          type="text"
                          @input="inputnum($event,index,'UserPerMonth')"
                          v-model="item.UserPerMonth"
                          placeholder="单位：万人（请填写大致范围，该信息仅供评选参考使用）"
                        ></el-input>
                      </el-form-item>
                      <el-form-item
                        label="大致月流水" 
                        prop="IncomePerMonth"
                        v-if="item.DeclareItem !='2026年度精选游戏运营企业' && item.DeclareItem !='2026年度精选社会价值游戏' && item.DeclareItem !='2026年度精选中华传统文化游戏' && item.DeclareItem !='2026年度精选游戏美术设计'  && item.DeclareItem != '2026年度精选游戏音乐设计' && item.DeclareItem !='2020年度中国游戏十强优秀游戏原创剧情奖' && item.DeclareItem != '2020年度中国游戏十强优秀游戏动画表现奖'"
                      >
                        <el-input
                          type="text"
                          @input="inputnum($event,index,'IncomePerMonth')"
                          v-model="item.IncomePerMonth"
                          placeholder="单位：万元（请填写大致范围，该信息仅供评选参考使用）"
                        ></el-input>
                      </el-form-item>
                      <el-form-item
                        :label="item.DeclareItem == '2026年度精选游戏音乐设计'?'音乐作品版权或版权授权证明复印件':item.DeclareItem == '2026年度精选游戏美术设计'?'美术作品版权或版权授权证明复印件':'著作权登记证书复印件'"
                        prop="GameIsbnPicID"
                      >
                        <el-upload
                          class="avatar-uploader"
                          :action="action"
                          :show-file-list="false"
                          :on-success="(res,file,fileList)=>handleAvatarSuccess3(res,file,fileList,index)"
                          :before-upload="beforeAvatarUpload1"
                          :on-progress="progressB"
                        >
                          <img
                            v-if="item.GameIsbnPicID && !isprogress1"
                            :src="pdfimg?require('../assets/pdf.jpg'):active+'?id='+item.GameIsbnPicID"
                            class="avatar"
                          />

                          <i
                            v-if="!item.GameIsbnPicID && !isprogress1"
                            class="el-icon-plus avatar-uploader-icon"
                          ></i>
                          <el-progress type="circle" v-if="isprogress1" :percentage="progressnumm1"></el-progress>
                          <span>著作权登记证书复印件（JPG、PNG、PDF）</span>
                        </el-upload>
                      </el-form-item>
                      <el-form-item
                        v-if="item.DeclareItem == '2020年度中国游戏十强优秀原创游戏IP奖'"
                        label="提供游戏IP授权或衍生品相关材料"
                        prop="FileID"
                      >
                        <el-upload
                          class="upload-demo"
                          drag
                          :limit="5"
                          :on-success="(res,file,fileList)=>handleAvatarSuccesslist2(res,file,fileList,index)"
                          :action="action"
                          :on-remove="(file,fileList)=>handleRemovefilit(file,fileList,index)"
                          :before-upload="beforeAvatarUpload6"
                        >
                          <i class="el-icon-upload"></i>
                          <div class="el-upload__text">
                            将文件拖到此处，或
                            <em>点击上传</em>
                          </div>
                          <div
                            class="el-upload__tip"
                            slot="tip"
                          >影视动漫相关介绍、衍生品生产介绍、其它活动等(只能上传DOC DOCX PDF WPS 文件且大小不能超过500M)</div>
                        </el-upload>
                      </el-form-item>
                      <el-form-item
                        class="custom_style"
                        v-if="item.DeclareItem == '2026年度精选游戏美术设计'"
                        label="提供产品相关原画集等艺术设计类材料"
                        prop="FileID"
                      >
                        <el-upload
                          class="upload-demo"
                          drag
                          :limit="10"
                          :on-success="(res,file,fileList)=>handleAvatarSuccesslist2(res,file,fileList,index,'fineArt')"
                          :action="action"
                          :on-remove="(file,fileList)=>handleRemovefilit(file,fileList,index,'fineArt')"
                          :before-upload="beforeAvatarUpload7"
                        >
                          <i class="el-icon-upload"></i>
                          <div class="el-upload__text">
                            将文件拖到此处，或
                            <em>点击上传</em>
                          </div>
                          <div
                            class="el-upload__tip"
                            slot="tip"
                          >上传4-10张图片，格式为JPEG或PNG格式，不低于1920X1080。</div>
                        </el-upload>
                      </el-form-item>
                      <el-form-item
                        class="custom_style"
                        v-if="item.DeclareItem == '2026年度精选游戏音乐设计'"
                        label="提供产品的原声集、游戏音效等音频文件"
                        prop="FileID"
                      >
                        <el-upload
                          class="upload-demo"
                          drag
                          :limit="5"
                          :on-success="(res,file,fileList)=>handleAvatarSuccesslist2(res,file,fileList,index,'music')"
                          :action="action"
                          :on-remove="(file,fileList)=>handleRemovefilit(file,fileList,index,'music')"
                          :before-upload="beforeAvatarUpload8"
                        >
                          <i class="el-icon-upload"></i>
                          <div class="el-upload__text">
                            将文件拖到此处，或
                            <em>点击上传</em>
                          </div>
                          <div
                            class="el-upload__tip"
                            slot="tip"
                          >最少2段；如原声专辑、音乐表演等(只能上传FLAC MP3 MP2 WAV OGG 文件且大小不能超过500M)。</div>
                        </el-upload>
                      </el-form-item>
                      <el-form-item
                        v-if="item.DeclareItem == '2020年度中国游戏十强优秀游戏原创剧情奖'"
                        label="提供参选游戏原创剧本、文案、背景设定等内容"
                        prop="FileID"
                      >
                        <el-upload
                          class="upload-demo"
                          drag
                          :limit="5"
                          :on-success="(res,file,fileList)=>handleAvatarSuccesslist2(res,file,fileList,index)"
                          :action="action"
                          :on-remove="handleRemovefilit"
                          :before-upload="beforeAvatarUpload9"
                        >
                          <i class="el-icon-upload"></i>
                          <div class="el-upload__text">
                            将文件拖到此处，或
                            <em>点击上传</em>
                          </div>
                          <div
                            class="el-upload__tip"
                            slot="tip"
                          >提供参选游戏原创剧本、文案、背景设定等内容(只能上传DOC DOCX PDF WPS文件且大小不能超过500M)</div>
                        </el-upload>
                      </el-form-item>
                      <el-form-item
                        v-if="item.DeclareItem == '2020年度中国游戏十强优秀游戏动画表现奖'"
                        label="申报游戏的动画视频"
                        prop="FileID"
                      >
                        <el-upload
                          class="upload-demo"
                          drag
                          :limit="5"
                          :on-success="(res,file,fileList)=>handleAvatarSuccesslist2(res,file,fileList,index)"
                          :action="action"
                          :on-remove="handleRemovefilit"
                          :before-upload="beforeAvatarUpload10"
                        >
                          <i class="el-icon-upload"></i>
                          <div class="el-upload__text">
                            将文件拖到此处，或
                            <em>点击上传</em>
                          </div>
                          <div
                            class="el-upload__tip"
                            slot="tip"
                          >申报游戏的动画视频(只能上传MP4 AVI MPG MOV M4V MKV文件且大小不能超过500M)</div>
                        </el-upload>
                      </el-form-item>
                    </template>
                  </el-form>
                </div>
              </div>
              <div class="addform" @click="addform('chanpin')" v-if="Entity.GameDeclareWorkInfo.length < 4">
                <img src="../assets/add.png" alt /> 继续填报产品
                <span>同一产品最多申报四个产品奖项</span>
              </div>
            </div>
          </div>
        </div>
        <demo :Entity="Entity" v-if="isactive == 3" :pdfimg="pdfimg"></demo>
        <div class="footer-form" v-if="isactive != 3">
          <el-button v-if="isactive != 0" @click="isactive--">上一步</el-button>
          <el-button v-else @click="dialogVisible = false">上一步</el-button>
          <el-button @click="submit">下一步</el-button>
          <el-button @click="entitySave">暂 存</el-button>
        </div>
        <div class="footer-form" v-if="isactive == 3">
          <el-button
            style="background:#fff;border:1px solid #d8b27e;color:#d8b27e"
            v-if="isactive != 0"
            @click="isactive--"
          >返回</el-button>
          <el-button @click="submit">确认申报</el-button>
        </div>
        <div class="footer-tips" v-if="isactive != 3">暂存功能仅限同一设备的同一浏览器使用</div>
        <div class="footer-active" v-if="isactive == 1 || isactive == 2">
          若无需申报{{isactive == 1?'企业':'产品'}}奖项可
          <span @click="tiaoguo">跳过</span>
        </div>
      </div>
    </el-dialog>
    <!-- 案例收录授权弹窗：选是/否均进入下一步，结果随 Entity 提交由后台记录 -->
    <el-dialog
      :visible.sync="agreeCaseVisible"
      width="460px"
      top="32vh"
      custom-class="agree-case-dialog"
      append-to-body
      :close-on-click-modal="false"
    >
      <div class="agree-case">
        <div class="agree-case__icon">
          <i class="el-icon-collection"></i>
        </div>
        <div class="agree-case__title">案例收录授权</div>
        <p class="agree-case__desc">
          参与本次征集且材料符合要求的产品、企业照片及文字素材，将作为精选案例被收录出版物<span
            class="agree-case__book"
          >《年度游戏行业精选案例汇编》</span>，是否同意？
        </p>
        <div class="agree-case__btns">
          <el-button
            class="agree-case__btn agree-case__btn_no"
            @click="handleAgreeCase(false)"
          >
            <i class="el-icon-close"></i>否
          </el-button>
          <el-button
            class="agree-case__btn agree-case__btn_yes"
            @click="handleAgreeCase(true)"
          >
            <i class="el-icon-check"></i>是
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Local, Session } from '@/common/js/util.js';
import demo from "./demo";
import provincecity from "@/components/ProvinceCity";
import { baseUrl, Add } from "@/config/index.js";
const all = (arr, fn = Boolean) => arr.every(fn);
export default {
  components: {
    provincecity,
    demo,
  },
  name: "index",
  data() {
    var isphone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("联系人手机号不能为空"));
      }
      setTimeout(() => {
        if (!/^1[3456789]\d{9}$/.test(value)) {
          callback(new Error("请输入正确的手机号"));
        } else {
          callback();
        }
      });
    };
    var isIsbn = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("不能为空"));
      }else if(!/^\d+-\d+-\d+-\d+-\d+$/.test(value)){
       return callback(new Error("请输入正确的版号"));
      }
       callback();
      // setTimeout(() => {
      //   if (!/\d-\d-\d-\d-\d$/.test(value)) {
      //     callback(new Error("请输入正确的版号"));
      //   } else {
      //     callback();
      //   }
      // });
    };
    var isTeamImgs = (rule, value, callback) => {
      if (value.length == 0) {
        return callback(new Error("该项不能为空"));
      } else if (value.length > 0 && value.length < 3) {
        if (value.length == 1 && value[0].type && value[0].type == 'VoIType') {
          let ext = value[0].name.split(".").pop().toLowerCase();
          if (ext == 'avi' || ext == 'mov' || ext == 'mp4') {
            callback();
          } else {
            return callback(new Error("上传图片不能少于4张"));
          }
        } else if (value.length <= 2 && value[0].type && value[0].type == 'qiyeVideos') {
          callback();
        } else {
          value.forEach((item) => {
            if (item.type && item.type == 'VoIType') {
              let ext = value[0].name.split(".").pop().toLowerCase();
              if (ext == 'jpeg' || ext == 'jpg' || ext == 'png') {
                return callback(new Error("上传图片不能少于4张"));
              } else {
                callback();
              }
            } else {
              return callback(new Error("请至少上传3个"));
            }
          })
          
        }
      } else if (value.length >= 3) {
        let i = 0;
        value.forEach((item) => {
          if (item.type && item.type == 'VoIType') {
            let ext = item.name.split(".").pop().toLowerCase();
            if (ext == 'jpeg' || ext == 'jpg' || ext == 'png') {
              i++;
              setTimeout(function() {
                if (i < 4) {
                  return callback(new Error("上传图片不能少于4张"));
                } else {
                  callback();
                }
              }, 60);
            } else if (ext == 'avi' || ext == 'mov' || ext == 'mp4' && i == 0) {
              callback();
            }
          } else {
            callback();
          }
        })
      } else {
        callback();
      }
    };
    var isImages = (rule, value, callback) => {
      if (value.length < 4) {
        return callback(new Error("请至少上传4张产品截图图片"));
      } else {
        callback();
      }
    };
    var isAudios = (rule, value, callback) => {
      if (!value || value.length == 0) {
        return callback(new Error("不能为空"));
      } else { 
        if (value.length < 2) {
          value.forEach((item) => {
            if (item.type && item.type == 'music') {
              return callback(new Error("请至少上传2段原声音频"));
            } else {
              callback();
            }
          })
        } else if (value.length >= 2 && value.length < 4) {
          value.forEach((item) => {
            if (item.type && item.type == 'fineArt') {
              return callback(new Error("上传图片不能少于4张"));
            } else {
              callback();
            }
          })
        } else if (value.length > 10) {
          value.forEach((item) => {
            if (item.type && item.type == 'fineArt') {
              return callback(new Error("上传图片最多不能超过10张"));
            } else {
              callback();
            }
          })
        } else {
          callback();
        }
      }
    };
    var strLens = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('该项不能为空'));
      }
      setTimeout(() => {
        if (value.length < 500) {
          callback(new Error('介绍字数不少于500字'));
        } else {
          callback();
        }
      }, 1000);
    };
    return {
      isSignup: true, // 是否申报
      // 申报流程列表
      sblcList:[
        { id: 1, name: "申报征集", time: "（2026年9月11日-10月9日）", imgurl: require("../assets/申报征集.png") },
        { id: 2, name: "汇总统计", time: "（2026年10月10日-10月11日）", imgurl: require("../assets/汇总统计.png") },
        { id: 3, name: "网络投票", time: "（2026年10月14日-10月20日晚18:00）", imgurl: require("../assets/网络投票.png") },
        { id: 4, name: "专家线上推荐", time: "（2026年10月19日-10月24日）", imgurl: require("../assets/专家线上推荐.png") },
        { id: 5, name: "入围名单复核", time: "（2026年10月27日-10月31日）", imgurl: require("../assets/专家线下评议.png") },
        { id: 6, name: "专家线下评议", time: "（2026年11月3日-11月7日）", imgurl: require("../assets/专家线下评议.png") },
        { id: 7, name: "报送复核", time: "（2026年11月10日-11月14日）", imgurl: require("../assets/报送复核.png") },
        { id: 8, name: "成果交流会", time: "（2026年12月中旬）", imgurl: require("../assets/授予奖项.png") },
      ],
      pickerOptions: {  
        disabledDate(time) {
          // return time.getTime() < Date.now() - 8.64e7;//如果没有后面的-8.64e7就是不可以选择今天的
          return time.getTime() > new Date('2026-10-09 00:00:00').getTime();//如果没有后面的-8.64e7就是不可以选择今天的
        } 
      },
      istabs: "1",
      pdfimg: false,
      isflage: [],
      // 获取图片
      active: `${baseUrl}/_Framework/GetFile`,
      // 上传
      action: `${baseUrl}/_Framework/UploadImage?1=1&_DONOT_USE_CS=default`,
      dialogVisible: false,
      agreeCaseVisible: false, // 案例收录授权弹窗
      isactive: 0,
      Entity: {
        // CompanyName: "中启",
        // PeopleName: "李工",
        // PeopleTel: "15066668888",
        // PeopleEmail: "123@qq.com",
        CompanyName: "",
        PeopleName: "",
        PeopleTel: "",
        PeopleEmail: "",
        IsAgreeCase: false, // 是否同意收录《年度游戏行业精选案例汇编》
        // ----
        // JoinCompanyName: "",
        // Introduction: "",
        // MainProductName: "",
        // ReceiveMoney: "",
        // LogoID: "",
        // ZZimgID: "",
        // Province: "",
        // PlateformInfo: "",
        // BelongCompanyName: "",
        // PlateformName: "",
        // ProductExportCountry: "",
        // shi: "",
        // PeopleNum: "",
        // DeclareItem: "",
        // TeamPhotoID: [],
        // ProductLogoID: "",
        // Website: "",
        // SocialResponsibility: "",
        GameDeclareWorkInfo: [
          {
            WorkName: "",
            Introduction: "",
            GameSportName: "",
            Isbn: "",
            StrongPoint: "",
            LogoID: "",
            AILogoID: "",
            LogoIDType: "img", // img -- 图片格式、 ai -- ai格式 、 psd -- psd格式
            CGID: "",
            OtherCG:"",
            Images: [],
            DeclareItem: "",
            InlineTime: "",
            WorkType: "",
            WokeInfo: "",
            TeamName: "",
            UserPerMonth: "",
            IncomePerMonth: "",
            GameIsbnPicID: "",
            FileID: [],
          },
        ],
        gameDeclareCompanyDeclares:[
          {
            JoinCompanyName: "",
            Introduction: "",
            MainProductName: "",
            ReceiveMoney: "",
            LogoID: "",
            AILogoID: "",
            LogoIDType: "img",
            ZZimgID: "",
            Province: "",
            PlateformInfo: "",
            BelongCompanyName: "",
            PlateformName: "",
            ProductExportCountry: "",
            Shi: "",
            PeopleNum: "",
            DeclareItem: "",
            TeamPhotoID: [],
            ProductLogoID: "",
            Website: "",
            SocialResponsibility: "",
          },
        ],
      },
      isFromTeamType:"",
      isDelTeamPic: false,
      isDelWorkArr: [
        {
          isDelImages: false,
        }
      ],// 触发产品中多图上传的删除时需要的
      isDelWorkArrQiye: [
        {
          isDelImages: false,
        }
      ],// 触发企业中多图上传的删除时需要的
      loadProgress: 0, // 动态显示进度条
      progressFlag: false, // 关闭进度条

      rules: {
        CompanyName: [
          { required: true, message: "请输入企业名称", trigger: "blur" },
        ],
        PeopleName: [
          { required: true, message: "请输入联系人名称", trigger: "blur" },
        ],
        PeopleTel: [{ required: true, validator: isphone, trigger: "blur" }],
        PeopleEmail: [
          {
            required: true,
            message: "请输入联系人邮箱",
            trigger: "blur",
          },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"],
          },
        ],
      },
      rules2: {
        BelongCompanyName: [
          { required: true, message: "该项不能为空", trigger: "blur" },
        ],
        PlateformName: [
          { required: true, message: "该项不能为空", trigger: "blur" },
        ],
        ProductExportCountry: [
          { required: true, message: "该项不能为空", trigger: "blur" },
        ],
        PlateformInfo: [
          { required: true, message: "该项不能为空", trigger: "blur" },
        ],
        JoinCompanyName: [
          { required: true, message: "请输入参选企业名称", trigger: "blur" },
        ],
        ProductExportCountry: [
          { required: true, message: "该项不能为空", trigger: "blur" },
        ],
        ReceiveMoney: [
          { required: true, message: "该项不能为空", trigger: "blur" },
        ],
        MainProductName: [
          { required: true, message: "请输入主要产品名称", trigger: "blur" },
        ],
        Province: [
          { required: true, message: "请选择地区", trigger: "change" },
        ],
        LogoID: [
          { required: true, message: "请上传参选企业LOGO", trigger: "change" },
        ],
        // AILogoID: [
        //   { required: true, message: "请上传参选企业LOGO对应ai格式", trigger: "change" },
        // ],
        ZZimgID: [
          {
            required: true,
            message: "请上传参选企业资质证明",
            trigger: "change",
          },
        ],
        TeamPhotoID: [
          {
            required: true,
            validator: isTeamImgs,
            trigger: "change",
          },
        ],
        Introduction: [
          {
            required: true,
            message: "请输入参选企业简介",
            trigger: "blur",
          },
        ],
        SocialResponsibility: [
          {
            required: true,
            validator: strLens,
            trigger: "blur",
          },
        ],
        DeclareItem: [
          { required: true, message: "请选择申报奖项", trigger: "change" },
        ],
        PeopleNum: [
          { required: true, message: "请选择人员数量", trigger: "change" },
        ],
        Website: [
          { required: true, message: "近一年围绕产品开展的运营工作介绍", trigger: ["blur", "change"] },
        ],
      },
      rules1: {
        WorkName: [
          { required: true, message: "请输入参选产品名称", trigger: "blur" },
        ],
        IncomePerMonth: [
          { required: true, message: "不能为空", trigger: "blur" },
        ],
        UserPerMonth: [
          { required: true, message: "不能为空", trigger: "blur" },
        ],
        TeamName: [
          { required: true, message: "请输入团队名称", trigger: "blur" },
        ],
        GameSportName: [
          { required: true, message: "不能为空", trigger: "blur" },
        ],
        Isbn: [{ required: true, validator: isIsbn, trigger: "blur" }],
        WokeInfo: [{ required: true, message: "不能为空", trigger: "blur" }],

        LogoID: [
          { required: true, message: "请上传产品LOGO", trigger: "change" },
        ],
        // AILogoID: [
        //   { required: true, message: "请上传产品LOGO对应ai格式", trigger: "change" },
        // ],
        GameIsbnPicID: [
          { required: true, message: "该项不能为空", trigger: "change" },
        ],
        InlineTime: [
          { required: true, message: "不能为空", trigger: "change" },
        ],
        CGID: [{ required: true, message: "请上传产品CG", trigger: "change" }],
        OtherCG: [{ required: true, message: "请上传运营活动宣传视频或图片", trigger: "change" }],
        Introduction: [
          {
            required: true,
            message: "请输入参选产品简介",
            trigger: "blur",
          },
        ],
        DeclareItem: [
          { required: true, message: "请选择申报奖项", trigger: "change" },
        ],
        WorkType: [
          { required: true, message: "请选择申报奖项", trigger: "change" },
        ],
        Images: [{ required: true, validator: isImages, trigger: "change" }],
        FileID: [{ required: true, validator: isAudios, trigger: "change" }],
      },
      checklist1: [
        {
          label: "综合奖",
          options: [
            {
              value: "2026年度精选移动游戏",
              html: `<p>征集主题向上、内容健康，玩法设计创新的高品质移动游戏出版物。</p><p>应当具备以下所有条件：</p><p>（1）具有深刻文化价值，弘扬正能量。</p><p>（2）拥有丰富的游戏内容和良好的游戏体验。</p><p>（3）拥有广泛用户基础，具备良好的社会和经济价值。</p>`,
              disabled: false,
            },
            {
              value: "2026年度精选客户端游戏",
              html: `<p>征集主题向上、内容健康，玩法设计创新的高品质客户端游戏出版物，包含电脑客户端和主机客户端游戏出版物。</p><p>应当具备以下所有条件：</p><p>（1）具有深刻文化价值，弘扬正能量。</p><p>（2）拥有丰富的游戏内容和良好的游戏体验。</p><p>（3）拥有广泛用户基础，具备良好的社会和经济价值。</p>`,
              disabled: false,
            },
            {
              value: "2026年度精选中华传统文化游戏",
              html: `<p>征集在弘扬传播中华优秀传统文化方面影响较大的游戏出版物。</p><p>应当具备以下所有条件：</p><p>（1）在游戏产品元素（题材、美术、音乐等）设计上体现中国传统文化相关内容。</p><p>（2）开展与中国传统文化相关的游戏运营活动。</p><p>（3）在国内外传播中国传统文化方面具有重大影响力。</p>`,
              disabled: false,
            },
            {
              value: "2026年度精选游戏音乐设计",
              html: `<p>征集在游戏内音乐创作方面风格突出的游戏出版物。</p><p>应当具备以下所有条件：</p><p>（1）具备较高的专业品质，在作曲、演奏、录音、混音等方面符合行业标准。</p><p>（2）音乐、音效、配音等与游戏剧情、画面紧密关联，代入感强，并可以让用户产生共鸣。</p><p>（3）音乐特色鲜明、风格独树一帜、具有清晰辨识度。</p>`,
              disabled: false,
            },
            {
              value: "2026年度精选游戏美术设计",
              html: `<p>征集内容题材新颖、主题表达精准，视觉效果优异的游戏出版物。</p><p>应当具备以下所有条件：</p><p>（1）个性鲜明，风格表现新颖。</p><p>（2）艺术性突出，富有想象力和创造力。</p><p>（3）美术创作中运用创新技术和手法表现。</p>`,
              disabled: false,
            },
            {
              value: "2026年度精选社会价值游戏",
              html: `<p>征集展现出优秀社会价值的游戏出版物。</p><p>应当具备以下所有条件：</p><p>（1）行业联动效应强，能够体现游戏的跨界融合能力。</p><p>（2）游戏设计以通过益智、科普、教育、社交互动等手段解决多领域社会问题为主要目的。</p><p>（3）娱乐性、可玩性、功能性兼备，具有良好的社会影响。</p>`,
              disabled: false,
            },
            
          ],
        },
      ],
      checklist2: [
        {
          value: "2026年度精选游戏科技创新企业",
          html: `<p>征集对新技术积极采纳、应用，在科技创新等方面有突出贡献，推动游戏行业高速化发展的游戏企业。</p><p>应当具备以下所有条件：</p><p>（1）在新兴游戏技术方面（AI、游戏引擎、实时渲染、物理仿真、云游戏等）取得创新成果、专利。</p><p>（2）鼓励通过以“游戏+”为前提，对丰富游戏产业内容进行多元化探索。</p><p>（3）将游戏科技与社会责任结合，以技术为导向，在游戏或其他传统领域具有一定的应用价值、社会价值。</p>`,
          disabled: false,
        },
        {
          value: "2026年度精选“走出去”游戏企业",
          html: `<p>征集在海外地区有进行市场运营并业绩良好的产品，具有一定的市场规模和竞争力的游戏企业。</p><p>应当具备以下所有条件：</p><p>（1）产品线丰富，覆盖多个海外地区，海外市场反响较好，用户规模较大，获得过当地国家、地区或行业奖项。</p><p>（2）自主研发的游戏产品在全球性发行平台排名靠前，获得较大经济效益。</p><p>（3）在中国文化“走出去”方面具有重大影响力的游戏企业。</p>`,
          disabled: false,
        },
        {
          value: "2026年度精选游戏研发团队",
          html: `<p>征集研发优秀游戏出版物的团队。</p><p>应当具备以下所有条件：</p><p>（1）研发团队有一个或者多个已正式上线运营的游戏产品，产品主题向上、内容健康，且在2026年度市场表现优异。</p><p>（2）团队有较高的凝聚力和集体荣誉感，以团队合作为主要目标，为团队目标共同努力。</p><p>（3）有计划地持续进行游戏更新维护工作，能按时、高质量地完成公司赋予的部门职能目标。</p>`,
          disabled: false,
        },
        {
          value: "2026年度精选游戏运营企业",
          html: `<p>征集开展优秀游戏运营及相关服务、活动的游戏企业。</p><p>应当具备以下所有条件：</p><p>（1）产品具有较长运营周期，具备成熟的运营模式、营销模式，提供良好的用户服务。</p><p>（2）产品持续拥有较好的用户口碑、用户活跃度及产品流水。</p><p>（3）运营活动形式丰富，拥有广泛的受众，具有出色的影响力和传播力。</p>`,
          disabled: false,
        },
      ],
      isprogress: false,
      progressnumm: 0,
      isprogress1: false,
      progressnumm1: 0,
      isprogressD: false,
      progressnummD: 0,
      isprogressE: false,
      progressnummE: 0,
      entityInfo: null, // 暂存申报信息
    };
  },
  mounted() {
    let that = this;
    setInterval((_) => {
      this.istabs = this.istabs == "1" ? "2" : "1";
    }, 8000);
    let entityInfo = Local.get('entityInfo') || null;
    this.entityInfo = entityInfo;
    if (entityInfo && Object.keys(entityInfo).length) {
      this.Entity = entityInfo;
      this.isDelWorkArrQiye = this.Entity.gameDeclareCompanyDeclares.map(x => {
        return {
          isDelImages: false
        }
      })
      this.isDelWorkArr = this.Entity.GameDeclareWorkInfo.map(x => {
        return {
          isDelImages: false
        }
      })
    }
    window.onbeforeunload = function (e) {
      if (that.dialogVisible && that.entityInfo === null) {
        e = e || window.event;
        if (e) {
          e.returnValue = "关闭提示";
        }
        return "关闭提示";
      }
    };
  },
  computed: {
    // 处理checklist1和checklist2数组，要求选中的选项，在新增的时候不可以再选，设置disabled，没有改奖项的收获才能选择
    processedChecklist1() {
      // 获取已选择的产品奖项
      const selectedProductAwards = this.Entity.GameDeclareWorkInfo
        .map(item => item.DeclareItem)
        .filter(item => item);
      
      // 返回处理后的checklist1，已选中的选项设置disabled
      return this.checklist1.map(group => ({
        ...group,
        options: group.options.map(option => ({
          ...option,
          disabled: selectedProductAwards.includes(option.value)
        }))
      }));
    },
    
    processedChecklist2() {
      // 获取已选择的企业奖项
      const selectedCompanyAwards = this.Entity.gameDeclareCompanyDeclares
        .map(item => item.DeclareItem)
        .filter(item => item);
      
      // 返回处理后的checklist2，已选中的选项设置disabled
      return this.checklist2.map(option => ({
        ...option,
        disabled: selectedCompanyAwards.includes(option.value)
      }));
    }
  },
  methods: {
    // 按下ctrl+alt+h时触发
    theAction() {
      this.isSignup = !this.isSignup;
    },
    tiaoguo() {
      if (this.isflage.length < 1 && this.isactive == 2) {
        this.$message.error("请填写企业奖项或产品奖项");
        return false;
      }
      if (this.isactive == 1 && this.Entity.gameDeclareCompanyDeclares[0].DeclareItem) {
        this.$confirm('跳过将清空当前页填写的企业申报信息，是否确认跳过？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.resetBusinessInfo();
          this.isactive++;
        }).catch(() => {});
        return;
      } else if (this.isactive == 2 && this.Entity.GameDeclareWorkInfo[0].DeclareItem) {
        this.$confirm('跳过将清空当前页填写的产品申报信息，是否确认跳过？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.resetWorkInfo();
          this.isactive++;
        }).catch(() => {});
        return;
      } else {
        if (this.isactive == 1) {
          this.resetBusinessInfo();
        }
        if (this.isactive == 2) {
          this.resetWorkInfo();
        }
        this.isactive++;
      }
    },
    // 重置企业信息
    resetBusinessInfo() {
      // this.$refs["ruledata"].resetFields();
      this.Entity.gameDeclareCompanyDeclares = [
        {
          JoinCompanyName: "",
          Introduction: "",
          MainProductName: "",
          ReceiveMoney: "",
          LogoID: "",
          AILogoID: "",
          LogoIDType: "img",
          ZZimgID: "",
          Province: "",
          PlateformInfo: "",
          BelongCompanyName: "",
          PlateformName: "",
          ProductExportCountry: "",
          Shi: "",
          PeopleNum: "",
          DeclareItem: "",
          TeamPhotoID: [],
          ProductLogoID: "",
          Website: "",
          SocialResponsibility: "",
        },
      ]
    },
    // 重置产品信息
    resetWorkInfo() {
      this.Entity.GameDeclareWorkInfo = [
        {
          WorkName: "",
          Introduction: "",
          GameSportName: "",
          Isbn: "",
          StrongPoint: "",
          LogoID: "",
          AILogoID: "",
          LogoIDType: "img",
          CGID: "",
          OtherCG:"",
          Images: [],
          DeclareItem: "",
          InlineTime: "",
          WorkType: "",
          WokeInfo: "",
          TeamName: "",
          UserPerMonth: "",
          IncomePerMonth: "",
          GameIsbnPicID: "",
          FileID: [],
        },
      ];
    },
    progressA(event, file, fileList) {
      this.isprogress = true;
      let percent = event.percent.toFixed(0);
      this.progressnumm = Number(percent);
      if (percent == 100) {
        setTimeout((_) => {
          this.isprogress = false;
        }, 1000);
      }
    },
    progressB(event, file, fileList) {
      this.isprogress1 = true;
      let percent = event.percent.toFixed(0);
      this.progressnumm1 = Number(percent);
      if (percent == 100) {
        setTimeout((_) => {
          this.isprogress1 = false;
        }, 1000);
      }
    },
    progressE(event, file, fileList) {
      this.isprogressE = true;
      let percent = event.percent.toFixed(0);
      this.progressnummE = Number(percent);
      if (percent == 100) {
        setTimeout((_) => {
          this.isprogressE = false;
        }, 1000);
      }
    },
    
    progressD(event, file, fileList) {
      this.isprogressD = true;
      let percent = event.percent.toFixed(0);
      this.progressnummD = Number(percent);
      if (percent == 100) {
        setTimeout((_) => {
          this.isprogressD = false;
        }, 1000);
      }
    },
    progressC(event, file, fileList, index,type) {
      if(type == 'qiye'){
        this.Entity.gameDeclareCompanyDeclares[index].isprogresszp = true;
        let percent = event.percent.toFixed(0);
        this.Entity.gameDeclareCompanyDeclares[index].progressnumm = Number(percent);
        this.Entity = { ...this.Entity };

        if (percent == 100) {
          setTimeout((_) => {
            this.Entity.gameDeclareCompanyDeclares[index].isprogresszp = false;
            this.Entity = { ...this.Entity };
          }, 1000);
        }
      }else{
        this.Entity.GameDeclareWorkInfo[index].isprogresszp = true;
        let percent = event.percent.toFixed(0);
        this.Entity.GameDeclareWorkInfo[index].progressnumm = Number(percent);
        this.Entity = { ...this.Entity };

        if (percent == 100) {
          setTimeout((_) => {
            this.Entity.GameDeclareWorkInfo[index].isprogresszp = false;
            this.Entity = { ...this.Entity };
          }, 1000);
        }
      }
      
    },
    progressAi(event, file, fileList, index,type) {
      if (type == 'ai_business') {
        this.Entity.gameDeclareCompanyDeclares[index].isprogressAi = true;
        let percent = event.percent.toFixed(0);
        this.Entity.gameDeclareCompanyDeclares[index].progressnummAi = Number(percent);
        this.Entity = { ...this.Entity };

        if (percent == 100) {
          setTimeout((_) => {
            this.Entity.gameDeclareCompanyDeclares[index].isprogressAi = false;
            this.Entity = { ...this.Entity };
          }, 1000);
        }
      } else if (type == 'ai_product') {
        this.Entity.GameDeclareWorkInfo[index].isprogressAi = true;
        let percent = event.percent.toFixed(0);
        this.Entity.GameDeclareWorkInfo[index].progressnummAi = Number(percent);
        this.Entity = { ...this.Entity };

        if (percent == 100) {
          setTimeout((_) => {
            this.Entity.GameDeclareWorkInfo[index].isprogressAi = false;
            this.Entity = { ...this.Entity };
          }, 1000);
        }
      }
    },
    // 处理 Entity 对象中上传数组
    handleUploadDelData() {
      // let teamPicArr = this.Entity.TeamPhotoID;
      // if (this.isDelTeamPic) {
      //   if (this.isFromTeamType == 'VoIType') {
      //     teamPicArr.forEach((ele, indexs) => {
      //       if (ele.raw.type.indexOf('video') != -1) {
      //         ele.url = require('../assets/video.png');
      //       }
      //       if (ele.response) {
      //         this.Entity.TeamPhotoID[indexs] = {
      //           type: 'VoIType',
      //           name: ele.name,
      //           url: this.active + "?id=" + ele.response.Data.Id,
      //         };
      //       }
      //     });
      //   } else {
      //     teamPicArr.forEach((ele, indexs) => {
      //       if (ele.response) {
      //         this.Entity.TeamPhotoID[indexs] = {
      //           name: ele.name,
      //           url: this.active + "?id=" + ele.response.Data.Id,
      //         };
      //       }
      //     });
      //   }
      // }
      let defaultArr = this.isDelWorkArr;//产品
      let flagArrChanpin = [];//产品
      let defaultArrQiye = this.isDelWorkArrQiye;//企业
      let flagArrChanpinQiye = [];//企业
      defaultArrQiye.forEach((item, index) => {
        if (item.isDelImages) {
          flagArrChanpinQiye.push(index);
        }
      });
      // 企业奖项数组
      if (flagArrChanpinQiye.length > 0) {
        let productArr = this.Entity.gameDeclareCompanyDeclares;
        for (let i = 0; i < productArr.length; i++) {
          const ele1 = productArr[i];
          for (let j = 0; j < flagArrChanpinQiye.length; j++) {
            const ele2 = flagArrChanpinQiye[j];
            if (i == ele2) {
              ele1.TeamPhotoID.forEach((item, idx) => {
                if (item.response) {
                  const isVideo = this.checkMediaType(item.name) == 'video';
                  this.Entity.gameDeclareCompanyDeclares[i].TeamPhotoID[idx] = {
                    name: item.name,
                    response: item.response,
                    // 视频条目用视频图标占位，真实文件地址由 response.Data.Id 还原
                    url: isVideo ? require('../assets/video.png') : (this.active + "?id=" + item.response.Data.Id),
                  };
                }
              });
            }
          }
        }
      }
      defaultArr.forEach((item, index) => {
        if (item.isDelImages) {
          flagArrChanpin.push(index);
        }
      });
      // 产品奖项数组
      if (flagArrChanpin.length > 0) {
        let productArr = this.Entity.GameDeclareWorkInfo;
        for (let i = 0; i < productArr.length; i++) {
          const ele1 = productArr[i];
          for (let j = 0; j < flagArrChanpin.length; j++) {
            const ele2 = flagArrChanpin[j];
            if (i == ele2) {
              ele1.Images.forEach((item, idx) => {
                if (item.response) {
                  this.Entity.GameDeclareWorkInfo[i].Images[idx] = {
                    name: item.name,
                    url: this.active + "?id=" + item.response.Data.Id,
                  };
                }
              });
            }
          }
        }
      }
    },
    submit() {
      // let isvalid = true;
      if (this.isactive == 0) {
        this.$refs["formdata"].validate((valid) => {
          if (valid) {
            // 仅基本信息步骤点下一步时弹窗确认案例收录授权，选是/否均进入下一步
            this.agreeCaseVisible = true;
          }
        });
      } else if (this.isactive == 1) {
        let arrlength = Number(this.Entity.gameDeclareCompanyDeclares.length);
        let flagArr = [];
        // 循环效验，不能跳出循环，否则后续表单不提示
        for (var i = 0; i < arrlength; i++) {
          let name = "ruledata";
          name += i;
          this.$refs[name][0].validate((valid) => {
            if (
              !this.Entity.gameDeclareCompanyDeclares[i].TeamPhotoID &&
              !this.Entity.gameDeclareCompanyDeclares[i].ProductLogoID &&
              this.Entity.gameDeclareCompanyDeclares[i].DeclareItem == "2026年度精选游戏研发团队"
            ) {
              this.$message.error("团队产品LOGO和团队成员合影必须填写一项");
              return false;
            }
            flagArr.push(valid);
          });
        }
        setTimeout(() => {
          if (all(flagArr)) {
            this.isactive = 2;
            this.isflage.push(1);
          }
        }, 0);
      } else if (this.isactive == 2) {
        this.handleUploadDelData();
        let arrlength = Number(this.Entity.GameDeclareWorkInfo.length);
        let flagArr = [];
        // 循环效验，不能跳出循环，否则后续表单不提示
        for (var i = 0; i < arrlength; i++) {
          let name = "ruleForm";
          name += i;
          this.$refs[name][0].validate((valid) => {
            flagArr.push(valid);
          });
        }
        setTimeout(() => {
          if (all(flagArr)) {
            console.log(this.Entity)
            this.isactive = 3;
            this.isflage.push(2);
          }
        }, 0);
        
      } else if (this.isactive == 3) {
        let Entity = this.deepClone(this.Entity);
        Entity.gameDeclareCompanyDeclares.forEach((item) => {
          let arr = [];
          if (item.TeamPhotoID.length > 0) {
            item.TeamPhotoID.forEach((el) => {
              // 视频条目的url是视频图标占位图，无法从url解析，优先从上传响应中取文件ID
              if (el.response && el.response.Data && el.response.Data.Id) {
                arr.push(el.response.Data.Id);
              } else if (el.url && el.url.indexOf("?id=") != -1) {
                arr.push(el.url.split("?id=")[1]);
              }
            });
            item.TeamPhotoID = arr.join(",");
          } else {
            item.TeamPhotoID = "";
          }
        });
        Entity.GameDeclareWorkInfo.forEach((item) => {
          let arr = [];
          if (item.Images.length > 0) {
            item.Images.forEach((el) => {
              // 视频条目的url是视频图标占位图，无法从url解析，优先从上传响应中取文件ID
              if (el.response && el.response.Data && el.response.Data.Id) {
                arr.push(el.response.Data.Id);
              } else if (el.url && el.url.indexOf("?id=") != -1) {
                arr.push(el.url.split("?id=")[1]);
              }
            });
            item.Images = arr.join(",");
          } else {
            item.Images = "";
          }

          let arrs = [];
          if (item.FileID.length > 0) {
            item.FileID.forEach((el) => {
              if (el.response) {
                arrs.push(el.response.Data.Id);
              } else {
                if (el.url.indexOf('=') != -1) {
                  arrs.push(el.url.split("=")[1]);
                } else {
                  arrs.push(el.url);
                }
              }
            });
            item.FileID = arrs.join(",");
          } else {
            item.FileID = "";
          }
        });

        Add({ Entity: Entity }).then((res) => {
          if (res.Success) {
            this.$message.success("申报成功");
            Local.remove('entityInfo');
            this.$router.push({
              name: "config",
            });
          } else {
            this.$message.error(res.ErrorMsg);
          }
        }).catch((error) => {
          // 请求异常（网络错误/超时/HTTP错误）时提取错误信息并提示
          let errorMsg = "提交失败，请稍后重试";
          if (error.response && error.response.data) {
            const data = error.response.data;
            if (typeof data === "string" && data) {
              errorMsg = data;
            } else if (data.ErrorMsg) {
              errorMsg = data.ErrorMsg;
            }
          } else if (error.message) {
            errorMsg = error.message;
          }
          this.$message.error(errorMsg);
        });
      }
    },
    // 案例收录授权选择，无论选是/否均进入下一步，结果随 Entity 提交由后台记录
    handleAgreeCase(agree) {
      this.Entity.IsAgreeCase = agree;
      this.agreeCaseVisible = false;
      this.isactive = 1;
    },
    // 数据暂存
    entitySave() {
      let Entity = this.deepClone(this.Entity);
      Local.set('entityInfo', Entity);
      this.entityInfo = Entity;
      this.$message.success("暂存成功");
    },
    inputnum(e, index, name) {
      e = e.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
      e = e.replace(/^\./g, ""); //验证第一个字符是数字而不是.
      e = e.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
      e = e.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      e = e.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
      // e = e.replace(/[^\d.]/g, "");
      // e = e.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
      this.Entity.GameDeclareWorkInfo[index][name] = e;
    },
    // 深拷贝
    deepClone(target) {
      // 定义一个变量
      let result;
      // 如果当前需要深拷贝的是一个对象的话
      if (typeof target === "object") {
        // 如果是一个数组的话
        if (Array.isArray(target)) {
          result = []; // 将result赋值为一个数组，并且执行遍历
          for (let i in target) {
            // 递归克隆数组中的每一项
            result.push(this.deepClone(target[i]));
          }
          // 判断如果当前的值是null的话；直接赋值为null
        } else if (target === null) {
          result = null;
          // 判断如果当前的值是一个RegExp对象的话，直接赋值
        } else if (target.constructor === RegExp) {
          result = target;
        } else {
          // 否则是普通对象，直接for in循环，递归赋值对象的所有值
          result = {};
          for (let i in target) {
            result[i] = this.deepClone(target[i]);
          }
        }
        // 如果不是对象的话，就是基本数据类型，那么直接赋值
      } else {
        result = target;
      }
      // 返回最终结果
      return result;
    },
    navflage() {
      this.isactive = 0;
      this.dialogVisible = true;
      this.$nextTick((_) => {
        // this.$refs["ruledata"].resetFields();
        this.$refs["formdata"].resetFields();
        // this.Entity.gameDeclareCompanyDeclares = [
        //   {
        //     JoinCompanyName: "",
        //     Introduction: "",
        //     MainProductName: "",
        //     ReceiveMoney: "",
        //     LogoID: "",
        //     AILogoID: "",
        //     ZZimgID: "",
        //     Province: "",
        //     PlateformInfo: "",
        //     BelongCompanyName: "",
        //     PlateformName: "",
        //     ProductExportCountry: "",
        //     Shi: "",
        //     PeopleNum: "",
        //     DeclareItem: "",
        //     TeamPhotoID: [],
        //     ProductLogoID: "",
        //     Website: "",
        //     SocialResponsibility: "",
        //   },
        // ]
        // this.Entity.GameDeclareWorkInfo = [
        //   {
        //     WorkName: "",
        //     Introduction: "",
        //     GameSportName: "",
        //     Isbn: "",
        //     StrongPoint: "",
        //     LogoID: "",
        //     AILogoID: "",
        //     CGID: "",
        //     OtherCG:"",
        //     Images: [],
        //     DeclareItem: "",
        //     InlineTime: "",
        //     WorkType: "",
        //     WokeInfo: "",
        //     TeamName: "",
        //     UserPerMonth: "",
        //     IncomePerMonth: "",
        //     GameIsbnPicID: "",
        //     FileID: [],
        //   },
        // ];
      });
    },
    cheselect(name, value, index) {
      console.log(name, value, index)
      this.$refs[name][0].resetFields();
      if (name == `ruledata` + index) {
        this.Entity.gameDeclareCompanyDeclares[index].JoinCompanyName = "";
        this.Entity.gameDeclareCompanyDeclares[index].Introduction = "";
        this.Entity.gameDeclareCompanyDeclares[index].MainProductName = "";
        this.Entity.gameDeclareCompanyDeclares[index].ReceiveMoney = "";
        this.Entity.gameDeclareCompanyDeclares[index].LogoID = "";
        this.Entity.gameDeclareCompanyDeclares[index].AILogoID = "";
        this.Entity.gameDeclareCompanyDeclares[index].LogoIDType = "img";
        this.Entity.gameDeclareCompanyDeclares[index].ZZimgID = "";
        this.Entity.gameDeclareCompanyDeclares[index].Province = "";
        this.Entity.gameDeclareCompanyDeclares[index].PlateformInfo = "";
        this.Entity.gameDeclareCompanyDeclares[index].BelongCompanyName = "";
        this.Entity.gameDeclareCompanyDeclares[index].PlateformName = "";
        this.Entity.gameDeclareCompanyDeclares[index].ProductExportCountry = "";
        this.Entity.gameDeclareCompanyDeclares[index].Shi = "";
        this.Entity.gameDeclareCompanyDeclares[index].PeopleNum = "";
        this.Entity.gameDeclareCompanyDeclares[index].DeclareItem = "";
        this.Entity.gameDeclareCompanyDeclares[index].TeamPhotoID = [];
        this.Entity.gameDeclareCompanyDeclares[index].ProductLogoID = "";
        this.Entity.gameDeclareCompanyDeclares[index].Website = "";
        this.Entity.gameDeclareCompanyDeclares[index].SocialResponsibility = "";
        this.$nextTick((_) => {
          this.Entity.gameDeclareCompanyDeclares[index].DeclareItem = value;
        });
      } else {
        this.Entity.GameDeclareWorkInfo[index].WorkName = "";
        this.Entity.GameDeclareWorkInfo[index].Introduction = "";
        this.Entity.GameDeclareWorkInfo[index].GameSportName = "";
        this.Entity.GameDeclareWorkInfo[index].Isbn = "";
        this.Entity.GameDeclareWorkInfo[index].StrongPoint = "";
        this.Entity.GameDeclareWorkInfo[index].LogoID = "";
        this.Entity.GameDeclareWorkInfo[index].AILogoID = "";
        this.Entity.GameDeclareWorkInfo[index].LogoIDType = "img";
        this.Entity.GameDeclareWorkInfo[index].CGID = "";
        this.Entity.GameDeclareWorkInfo[index].OtherCG = "";
        this.Entity.GameDeclareWorkInfo[index].Images = [];
        this.Entity.GameDeclareWorkInfo[index].DeclareItem = "";
        this.Entity.GameDeclareWorkInfo[index].InlineTime = "";
        this.Entity.GameDeclareWorkInfo[index].WorkType = "";
        this.Entity.GameDeclareWorkInfo[index].WokeInfo = "";
        this.Entity.GameDeclareWorkInfo[index].TeamName = "";
        this.Entity.GameDeclareWorkInfo[index].UserPerMonth = "";
        this.Entity.GameDeclareWorkInfo[index].IncomePerMonth = "";
        this.Entity.GameDeclareWorkInfo[index].GameIsbnPicID = "";
        this.Entity.GameDeclareWorkInfo[index].FileID = [];
        this.$nextTick((_) => {
          this.Entity.GameDeclareWorkInfo[index].DeclareItem = value;
        });
      }
    },
    selectChange(Province, shi,index) {
      this.Entity.gameDeclareCompanyDeclares[index].Province = Province;
      this.Entity.gameDeclareCompanyDeclares[index].Shi = shi;
    },
    // 企业logo
    handleAvatarSuccess2(res, val) {
      if (res.Code == 200) {
        this.$message.success("上传成功");
      } else {
        this.$message.error("上传失败");
      }
      this.Entity[val] = res.Data.Id;
    },
    // 图片上传回调
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 或 png 格式!");
      }
      return isJPG;
    },
    // 图片上传回调
    beforeAvatarUpload5(file) {
      this.isFromTeamType = "";
      this.isDelTeamPic = false;
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";

      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG 或 png 格式!");
      }
      return isJPG;
    },
    // 文档上传回调
    beforeAvatarUpload6(file) {
      var ext = file.name.split(".").pop();
      let isJPG = ext == "doc" || ext == "docx" || ext == "pdf" || ext == "wps";
      if (!isJPG) {
        this.$message.error("只支持DOC DOCX PDF WPS 类型文件");
      }
      return isJPG;
    },
    async beforeAvatarUpload7(file) {
      var ext = file.name.split(".").pop();

      let isJPG =
        ext == "jpg" ||
        ext == "jpeg" ||
        ext == "png";
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG 或 png 格式!");
      }
      const isSize = await new Promise(function (resolve, reject) {
        let width = 1920;
        let height = 1080;
        let _URL = window.URL || window.webkitURL
        let image = new Image();

        image.onload = function () {
          const valid =
            image.width >= width &&
            image.height >= height;
          valid ? resolve() : reject();
        }
        image.src = _URL.createObjectURL(file)
      }).then(() => {
        return file
      },() => {
        this.$message.error('上传的图片不低于1920X1080');
        return Promise.reject(false);
      })
      return isJPG && isSize;
    },
    beforeAvatarUpload8(file) {
      var ext = file.name.split(".").pop();

      let isJPG =
        ext == "flac" ||
        ext == "mp3" ||
        ext == "mp2" ||
        ext == "wav" ||
        ext == "ogg";
      if (!isJPG) {
        this.$message.error("只支持FLAC MP3 MP2 WAV OGG 类型文件");
      }
      return isJPG;
    },
    beforeAvatarUpload9(file) {
      var ext = file.name.split(".").pop();

      let isJPG = ext == "doc" || ext == "docx" || ext == "pdf" || ext == "wps";
      if (!isJPG) {
        this.$message.error("只支持DOCX DOC PDF WPS类型文件");
      }
      return isJPG;
    },
    beforeAvatarUpload10(file) {
      var ext = file.name.split(".").pop();
      let isJPG =
        ext == "mp4" ||
        ext == "avi" ||
        ext == "mpg" ||
        ext == "mov" ||
        ext == "m4v" ||
        ext == "mkv";
      if (!isJPG) {
        this.$message.error("只支持MP4 AVI MPG M4V MKV MOV类型文件");
      }
      return isJPG;
    },
    // 图片上传回调
    beforeAvatarUpload1(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "application/pdf";

      if (!isJPG) {
        this.$message.error("上传格式只能是 JPG，PNG 或 PDF 格式!");
      }
      if (file.type === "image/jpeg" || file.type === "image/png") {
        this.pdfimg = false;
        // const isLt3M = file.size / 1024 / 1024 > 3;
        // if (!isLt3M) {
        //   this.$message.error('上传图片大小不能低于 3M!');
        // }
        return isJPG;
      } else if (file.type === "application/pdf") {
        this.pdfimg = true;
        return isJPG;
      }
      return false;
    },
    // 图片上传回调
    async beforeAvatarUpload2(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      // const isLt2M = file.size / 1024 / 1024 > 2;
      // const isSize = await new Promise(function (resolve, reject) {
      //   let _URL = window.URL || window.webkitURL
      //   let image = new Image();
      //   image.onload = function () {
      //     let width = image.width;//获取图片的宽
      //     let height = image.height;//获取图片的高
      //     let valid = width * height * 4;
      //     valid >= 8294400 ? resolve() : reject();
      //   }
      //   image.src = _URL.createObjectURL(file)
      // }).then(() => {
      //   return file
      // },() => {
      //   this.$message.error('上传的图片分辨率不小于2k');
      //   return Promise.reject(false);
      // })

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 或 png 格式!");
      }
      // if (!isLt2M) {
      //   this.$message.error('上传图片大小不能小于 2M!')
      // }
      return isJPG;
    },
    // 图片上传回调
    beforeAvatarUpload3(file,index,type) {
      if(type == 'qiye'){
        this.isDelWorkArrQiye[index].isDelImages = false;
      }else{
        this.isDelWorkArr[index].isDelImages = false;
      }
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      // const isSize = await new Promise(function (resolve, reject) {
      //   let width = 1920;
      //   let height = 1080;
      //   let _URL = window.URL || window.webkitURL
      //   let image = new Image();

      //   image.onload = function () {
      //     const valid =
      //       image.width >= width &&
      //       image.height >= height;
      //     valid ? resolve() : reject();
      //   }
      //   image.src = _URL.createObjectURL(file)
      // }).then(() => {
      //   return file
      // },() => {
      //   this.$message.error('上传的图片清晰度不能低于1080P');
      //   return Promise.reject(false);
      // })
      const isLt3M = file.size / 1024 / 1024 > 3;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG 或 png 格式!");
      }
      if (!isLt3M) {
        this.$message.error('上传图片大小不能低于 3M!')
      }
      return isLt3M && isJPG;
    },
    // ai 格式文件上传之前
    beforeAvatarUploadAi(file) {
      const isAI = file.type === "application/postscript";
      // const isLt2M = file.size / 1024 / 1024 > 2;
      // if (!isLt2M) {
      //   this.$message.error('上传图片大小不能小于 2M!')
      // }
      if (!isAI) {
        this.$message.error("上传文件只能是 ai 格式!");
      }
      return isAI;
    },
    // 支持 jpg、png和ai和psd格式的文件上传 
    beforeAvatarUploadThreeTypes(file) {
      const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1).toLowerCase();
      const whiteList = ['png', 'ai', "psd"];
      const isFileFlag = whiteList.includes(fileSuffix);
      if (!isFileFlag) {
        this.$message.error("上传文件只能是 png 或 ai 或 psd 格式!");
      }
      // const isLt3M = file.size / 1024 / 1024 > 3;
      // if (!isLt3M) {
      //   this.$message.error('上传文件不能小于 3M!')
      // }
      return isFileFlag;
    },
    // 图片上传回调
    beforeAvatarUploadNew(file,index,type) {
      if(type == 'qiye'){
        this.isDelWorkArrQiye[index].isDelImages = false;
      }else{
        this.isDelWorkArr[index].isDelImages = false;
      }
      var ext = file.name.split(".").pop();
      let isJPGVideo =
        ext == "mp4" ||
        ext == "avi" ||
        ext == "mpg" ||
        ext == "mov" ||
        ext == "m4v" ||
        ext == "mkv";
      const isJPGImage = file.type === "image/jpeg" || file.type === "image/png";
      if (!isJPGImage && !isJPGVideo) {
        this.$message.error("只能上传图片和视频格式!");
      }
      
      if (isJPGImage) {
        const isLt3M = file.size / 1024 / 1024 > 3;
        if (!isLt3M) {
          this.$message.error('上传图片大小不能低于 3M!')
        }
        return isJPGImage && isLt3M;
      } else if (isJPGVideo) {
        return isJPGVideo;
      }
      return false;
    },
    // 图片上传
    handleAvatarSuccess(res, file, fileList, index,type) {
      if (res.Code == 200) {
        this.$message.success("上传成功");
        // 获取res Data 中Name的后缀
        const nameSuffix = res.Data.Name ? res.Data.Name.substring(res.Data.Name.lastIndexOf(".") + 1).toLowerCase() : "";
        // 根据后缀设置类型
        let nameType = "img";
        if (nameSuffix) {
          if (nameSuffix === 'ai') {
            nameType = "ai";
          } else if (nameSuffix === 'psd') {
            nameType = "psd";
          }
        }
        if(type == 'qiye'){
          this.Entity.gameDeclareCompanyDeclares[index].LogoID = res.Data.Id;
          this.Entity.gameDeclareCompanyDeclares[index].LogoIDType = nameType;
        } else if (type == 'ai_business') {
          this.Entity.gameDeclareCompanyDeclares[index].AILogoID = res.Data.Id;
          this.Entity.gameDeclareCompanyDeclares[index].LogoIDType = nameType;
        } else if (type == 'ai_product') {
          this.Entity.GameDeclareWorkInfo[index].AILogoID = res.Data.Id;
          this.Entity.GameDeclareWorkInfo[index].LogoIDType = nameType;
        } else{
          this.Entity.GameDeclareWorkInfo[index].LogoID = res.Data.Id;
          this.Entity.GameDeclareWorkInfo[index].LogoIDType = nameType;
        }
      } else {
        this.$message.error("上传失败");
      }
    },
    // 图片上传
    handleAvatarSuccess3(res, file, fileList, index,type) {
      if (res.Code == 200) {
        this.$message.success("上传成功");
      } else {
        this.$message.error("上传失败");
      }
      if(type == 'qiye'){
        this.Entity.gameDeclareCompanyDeclares[index].ZZimgID = res.Data.Id;
      }else{
        this.Entity.GameDeclareWorkInfo[index].GameIsbnPicID = res.Data.Id;
      }
    },
    
    // 图片上传
    handleAvatarSuccessA(res, file, fileList, index,type) {
      if (res.Code == 200) {
        this.$message.success("上传成功");
      } else {
        this.$message.error("上传失败");
      }
      if(type == 'qiye'){
        this.Entity.gameDeclareCompanyDeclares[index].PlateformInfo = res.Data.Id;
        
      }else{
        this.Entity.GameDeclareWorkInfo[index].GameIsbnPicID = res.Data.Id;
      }
    },
    // 团队照片删除
    handleTeamPicRemove(file, fileList,type) {
      if (type == 'VoIType') {
        this.isFromTeamType = 'VoIType';
      } else {
        this.isFromTeamType = '';
      }
      this.isDelTeamPic = true;
      this.Entity.TeamPhotoID = fileList;
    },
    // 贡献游戏企业上传工作照片或视频
    handleCompanySuccess(res, file, fileList,type) {
      this.isDelTeamPic = false;
      if (res.Code == 200) {
        this.$message.success("上传成功");
      } else {
        this.$message.error("上传失败");
      }
      fileList.forEach((ele, indexs) => {
        const isVideo = ele.raw && ele.raw.type && ele.raw.type.indexOf('video') != -1;
        if (isVideo) {
          ele.url = require('../assets/video.png');
        }
        if (ele.response) {
          this.Entity.TeamPhotoID[indexs] = {
            type: type == 'VoIType' ? 'VoIType' : '',
            response: ele.response,
            name: ele.name,
            // 视频条目用视频图标占位，真实文件地址由 response.Data.Id 在提交/预览时还原
            url: isVideo ? require('../assets/video.png') : (this.active + "?id=" + ele.response.Data.Id),
          };
        }
      });
    },
    checkMediaType(url) {
      // 获取路径部分（去除参数）
      var path = url;
      // 获取路径的最后一个点之后的内容作为文件扩展名
      var extension = path.split('.').pop().toLowerCase();
      // 声明支持的图片和视频文件扩展名
      var imageExtensions = ['jpg', 'jpeg', 'png'];
      var videoExtensions = ['mp4', 'avi', 'mov', 'mpg', 'm4v', 'mkv'];
      // 判断文件扩展名是否在图片扩展名数组中
      if (imageExtensions.includes(extension)) {
        return 'image';
      }
      // 判断文件扩展名是否在视频扩展名数组中
      if (videoExtensions.includes(extension)) {
        return 'video';
      }
      // 扩展名不在图片或视频数组中，返回null表示无法确定媒体类型
      return null;
    },
    // 批量图片上传上传
    handleAvatarSuccesslist(res, file, fileList, index,type) {
      if(type == 'qiye'){
        this.isDelWorkArrQiye[index].isDelImages = false;
        if (res.Code == 200) {
          this.$message.success("上传成功");
        } else {
          this.$message.error("上传失败");
        }
        var _this = this;
        fileList.forEach(async function(ele, indexs){
          if (ele.response) {
            if(await _this.checkMediaType(ele.name) == "image"){
              _this.Entity.gameDeclareCompanyDeclares[index].TeamPhotoID[indexs] = {
                name: ele.name,
                url: _this.active + "?id=" + ele.response.Data.Id,
              };
            }else if(await _this.checkMediaType(ele.name) == "video"){
              ele.url = require('../assets/video.png');
              _this.Entity.gameDeclareCompanyDeclares[index].TeamPhotoID[indexs] = {
                response: ele.response,
                name: ele.name,
                // 视频条目用视频图标占位，真实文件地址由 response.Data.Id 在提交/预览时还原
                url: require('../assets/video.png')
              };
            }
            
          }
        });
      }else{
        this.isDelWorkArr[index].isDelImages = false;
        if (res.Code == 200) {
          this.$message.success("上传成功");
        } else {
          this.$message.error("上传失败");
        }
        fileList.forEach((ele, indexs) => {
          if (ele.response) {
            this.Entity.GameDeclareWorkInfo[index].Images[indexs] = {
              name: ele.name,
              url: this.active + "?id=" + ele.response.Data.Id,
            };
          }
        });
      }
      
    },
    // 删除产品截图
    handleRemove(file,fileList,index,type) {
      if(type == 'qiye'){
        this.isDelWorkArrQiye[index].isDelImages = true;
        this.Entity.gameDeclareCompanyDeclares[index].TeamPhotoID = fileList;
      }else{
        this.isDelWorkArr[index].isDelImages = true;
        this.Entity.GameDeclareWorkInfo[index].Images = fileList;
      }
      
    },
    // 批量图片上传上传
    handleAvatarSuccesslist2(res, file, fileList, index, type) {
      if (res.Code == 200) {
        this.$message.success("上传成功");
      } else {
        this.$message.error("上传失败");
      }
      let arr = [];
      fileList.forEach((item) => {
        arr.push({
          type: type == 'music' ? 'music' : type == 'fineArt' ? 'fineArt' : '',
          name: item.name,
          url: item.response.Data.Id,
        });
      });
      this.Entity.GameDeclareWorkInfo[index].FileID = arr;
    },
    // 产品实机演示视频上传成功
    handleVideoSuccess(res, file, fileList, index,type) {
      if(type == 'qiye'){
        if (res.Code == 200) {
          this.$message.success("上传成功");
        } else {
          this.$message.error("上传失败");
        }
        fileList.forEach((item, idx) => {
          item.url = require('../assets/video.png');
          if(item.response){
            this.Entity.gameDeclareCompanyDeclares[index].TeamPhotoID[idx] = {
              type: 'qiyeVideos',
              response: item.response,
              name: item.name,
              // 视频条目用视频图标占位，真实文件地址由 response.Data.Id 在提交/预览时还原
              url: require('../assets/video.png'),
            };
          }
        });
      }else{
        if (res.Code == 200) {
          this.$message.success("上传成功");
        } else {
          this.$message.error("上传失败");
        }
        fileList.forEach((item, idx) => {
          item.url = require('../assets/video.png');
          this.Entity.GameDeclareWorkInfo[index].FileID[idx] = {
            response: item.response,
            name: item.name,
            // 视频条目用视频图标占位，真实文件地址由 response.Data.Id 在提交/预览时还原
            url: require('../assets/video.png')
          };
        });
      }
      
    },
    // 产品实机演示视频删除
    handleVideoRemovefilit(file, fileList, index,type) {
      if(type == 'qiye'){
        this.Entity.gameDeclareCompanyDeclares[index].TeamPhotoID = [...fileList];
      }else{
        this.Entity.GameDeclareWorkInfo[index].FileID = [...fileList];
      }
    },
    handleRemovefilit(file, fileList, index, type) {
      let arr = [];
      fileList.forEach((item) => {
        arr.push({
          type: type == 'music' ? 'music' : type == 'fineArt' ? 'fineArt' : '',
          name: item.name,
          url: item.response.Data.Id,
        });
      });
      this.Entity.GameDeclareWorkInfo[index].FileID = arr;
    },
    // 视频上传回调
    beforeAvatarUploadview(file) {
      const isVideo = file.type === "video/avi" || file.type === "video/mov" || file.type === "video/quicktime" || file.type === "video/mp4";
      if (!isVideo) {
        this.$notify({
          title: "失败",
          message: "上传视频格式只能为 AVI/MOV/mp4 格式!",
          type: "error",
          duration: 3000,
        });
      }
      const isLt1G = file.size / 1024 / 1024 < 1024;
      if (!isLt1G) {
        this.$notify({
          title: "失败",
          message: "上传视频不能大于1G",
          type: "error",
          duration: 3000,
        });
      }
      
      // const isSize = await new Promise(function (resolve, reject) {
      //   let _URL = window.URL || window.webkitURL;
      //   let url = _URL.createObjectURL(file);
      //   let audioElement = document.createElement('video');
      //   audioElement.src = url;
      //   audioElement.addEventListener('loadedmetadata', function (_event) {
      //     if (audioElement.videoWidth != 1920 || audioElement.videoHeight != 1080) {
      //       reject();
      //     } else {
      //       resolve();
      //     }
      //   });
      // }).then(() => {
      //   return file
      // },() => {
      //   this.$message.error('上传视频清晰度不能低于1080P');
      //   return Promise.reject(false);
      // })
      
      return isVideo && isLt1G;
    },
    // 产品实机演示视频上传前回调
    beforeVideoUploadview(file) {
      const isVideo = file.type === "video/avi" || file.type === "video/mov" || file.type === "video/quicktime" || file.type === "video/mp4";
      if (!isVideo) {
        this.$notify({
          title: "失败",
          message: "上传视频格式只能为 AVI/MOV/mp4 格式!",
          type: "error",
          duration: 3000,
        });
      }

      const isLt1G = file.size / 1024 / 1024 < 1024;
      if (!isLt1G) {
        this.$notify({
          title: "失败",
          message: "上传视频不能大于1G",
          type: "error",
          duration: 3000,
        });
      }
      return isVideo && isLt1G;
    },
    // 视频上传E
    handleAvatarSuccessview(res, file, fileList, index) {
      if (res.Code == 200) {
        this.$message.success("上传成功");
      } else {
        this.$message.error("上传失败");
      }
      this.Entity.GameDeclareWorkInfo[index].CGID = res.Data.Id;
    },
    //运营活动宣传视频或图片
    handleAvatarSuccessview2(res, file, fileList, index) {
      if (res.Code == 200) {
        this.$message.success("上传成功");
      } else {
        this.$message.error("上传失败");
      }
      this.Entity.gameDeclareCompanyDeclares[index].ProductLogoID = res.Data.Id;
    },
    addform(type) {
      if(type == 'qiye'){
        this.Entity.gameDeclareCompanyDeclares.push({
            JoinCompanyName: "",
            Introduction: "",
            MainProductName: "",
            ReceiveMoney: "",
            LogoID: "",
            AILogoID: "",
            LogoIDType: "img",
            ZZimgID: "",
            Province: "",
            PlateformInfo: "",
            BelongCompanyName: "",
            PlateformName: "",
            ProductExportCountry: "",
            Shi: "",
            PeopleNum: "",
            DeclareItem: "",
            TeamPhotoID: [],
            ProductLogoID: "",
            Website: "",
            SocialResponsibility: "",
          })
          this.isDelWorkArrQiye.push({
            isDelImages: false
          })
      }else{
        this.Entity.GameDeclareWorkInfo.push({
          WorkName: "",
          Introduction: "",
          GameSportName: "",
          Isbn: "",
          StrongPoint: "",
          LogoID: "",
          AILogoID: "",
          LogoIDType: "img",
          CGID: "",
          OtherCG:"",
          Images: [],
          DeclareItem: "",
          InlineTime: "",
          WorkType: "",
          WokeInfo: "",
          TeamName: "",
          UserPerMonth: "",
          IncomePerMonth: "",
          GameIsbnPicID: "",
          FileID: [],
        });
        this.isDelWorkArr.push({
          isDelImages: false
        })
      }
    },
    closeesc(index,type) {
      if(type == 'qiye'){
        this.Entity.gameDeclareCompanyDeclares.splice(index, 1);
        this.isDelWorkArrQiye.splice(index, 1);
      }else{
        this.Entity.GameDeclareWorkInfo.splice(index, 1);
        this.isDelWorkArr.splice(index, 1);
      }
      
    },
    uploadVideoProcess(event, file, fileList, index) {
      this.Entity.GameDeclareWorkInfo[index].isprogressview = true;
      let percent = event.percent.toFixed(0);
      this.Entity.GameDeclareWorkInfo[index].progressnumm = Number(percent);
      this.Entity = { ...this.Entity };

      if (percent == 100) {
        setTimeout((_) => {
          this.Entity.GameDeclareWorkInfo[index].isprogressview = false;
          this.Entity = { ...this.Entity };
        }, 1000);
      }
    },
    uploadVideoProcess2(event, file, fileList, index) {
      this.Entity.gameDeclareCompanyDeclares[index].isprogressview2 = true;
      let percent = event.percent.toFixed(0);
      this.Entity.gameDeclareCompanyDeclares[index].progressnumm2 = Number(percent);
      this.Entity = { ...this.Entity };

      if (percent == 100) {
        setTimeout((_) => {
          this.Entity.gameDeclareCompanyDeclares[index].isprogressview2 = false;
          this.Entity = { ...this.Entity };
        }, 1000);
      }
    },
  },
};
</script>

<style lang="scss">
html::-webkit-scrollbar {
  width: 0;
  height: 0;
  /**/
}
textarea::-webkit-scrollbar {/*滚动条整体样式*/
  width: 8px;     /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
textarea::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
  border-radius: 8px;
  -webkit-box-shadow: inset 0 0 4px rgba(0,0,0,0.2);
  background: #535353;
}
textarea::-webkit-scrollbar-track {/*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 4px rgba(0,0,0,0.2);
  border-radius: 8px;
  background: #EDEDED;
}

.el-dialog__wrapper {
  background: #394859;
}
.index {
  .title {
    img {
      width: 3.29rem !important;
      height: auto;
    }
  }
  position: relative;
  .el-steps--horizontal {
    margin-top: 20px;
  }
  width: 19.2rem;
  .imagess {
    position: relative;
    width: 100%;
    background: #000 url("../assets/1920_y2026.png") no-repeat;
    background-size: 100%;
    // height: 34.7rem;
    overflow: hidden;

    .logo {
      width: 1.45rem;
      height: 0.7rem;
      margin: 1.11rem auto 0.08rem;
      transform: translateX(-7.75rem);
      img {
        width: 100%;
        height: auto;
      }
    }

    .nav_title {
      width: 12.61rem;
      height: 3.45rem;
      margin: 0 auto;
      margin-bottom: 0.48rem;
      img {
        width: 100%;
        height: auto;
      }
    }

    .nav {
      margin: 0 auto;
      width: 4.12rem;
      height: 1.21rem;
      // opacity: 0.2;
      margin-bottom: 1.78rem;
      &_signup {
        cursor: pointer;
        background: url("../assets/申报入口_2025.png") no-repeat center center;
        background-size: 100%;
      }
      &_no_signup {
        cursor: not-allowed; 
        background: url("../assets/申报已截止_2025.png") no-repeat center center;
        background-size: 100%;
      }
    }
    .nav_arrow {
      width: 0.42rem;
      height: 0.5rem;
      margin: 0.07rem auto 1rem;
      background: url("../assets/icon_xia.png") no-repeat center center;
      background-size: 100%;
    }

    .hdjj_title,
    .zzjg_title,
    .jxmc_title,
    .hllj_title {
      width: 1.85rem;
      height: 1.51rem;
      margin: 0 auto;
      margin-bottom: 0.61rem;
      img {
        width: 100%;
        height: auto;
      }
      // margin-top: 0.91rem;
      // text-align: center;
      // font-size: 0.51rem;
      // font-family: Microsoft YaHei;
      // color: rgba(247, 209, 148, 1);
      // font-weight: 700;
      // height: 0.5rem;
    }
    .modle_wrap {
      width: 9.52rem;
      margin: 0 auto;
      margin-top: 0.61rem;
      margin-bottom: 1.47rem;
      box-sizing: border-box;
      border: solid 2px #CCA56B;
      padding: 0.56rem 0.5rem;
      border-radius: 0.24rem;
      position: relative;
      &::before {
        position: absolute;
        content: "";
        display: block;
        width: 1.08rem;
        height: 1.06rem;
        background: url("../assets/handle_up.png") no-repeat center center;
        background-size: 100%;
        top: -0.7rem;
        left: -0.7rem;
      }
      &::after {
        position: absolute;
        content: "";
        display: block;
        width: 1.08rem;
        height: 1.06rem;
        background: url("../assets/handle_down.png") no-repeat center center;
        background-size: 100%;
        bottom: -0.7rem;
        right: -0.7rem;
      }
    }
    .hdjj-content {
      width: 100%;
      font-size: 0.24rem;
      color: rgba(216, 185, 134, 1);
      line-height: 0.41rem;
      p {
        font-size: 0.24rem;
        text-align: left;
        text-indent: 0.56rem;
      }
    }
    .zzjg-content {
      // width: 100%;
      margin: 0 auto;
      font-size: 0.24rem;
      display: flex;
      flex-direction:column;
      justify-content:center;

      p {
        width: 3.6rem;
        margin: 0 auto;
        font-size: 0.24rem;
        text-align: left;
        color: rgba(247, 209, 148, 1);
        line-height: 0.5rem;
        height: 0.48rem;
      }
      p:last-child{
        // text-align: center;
      }
    }
    .jxmc_wrap {
      padding: 0.42rem 0 0.5rem;
      .isjx {
        font-size: 0.36rem;
        color: rgba(247, 209, 148, 1);
        position: relative;
      }
      .isjxactive::after {
        width: 0.5rem;
        height: 2px;
        content: "";
        display: block;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
      }

      .jxmc-content {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        // margin-top: 0.28rem;
        // padding: 0 16.5%;
        box-sizing: border-box;
        justify-content: center;
        img {
          width: 2.71rem;
          height: auto;
          margin-left: 2.9rem;
          &:nth-child(2) {
            margin-left: 0;
            margin-right: 2.9rem;
          }
        }
        .center {
          width: 3.8rem;
          margin: 0 auto;
        }
        // div {
        //   width: 50%;
        // }
        .left {
          padding-right: 0.2rem;
          box-sizing: border-box;
        }
        .right {
          padding-left: 0.2rem;
          box-sizing: border-box;
        }
        p {
          height: 0.4rem;
          font-size: 0.24rem;
          color: rgba(247, 209, 148, 1);
          font-weight: 400;
          width: 100%;
          margin-top: 0.16rem;
          text-align: left;
        }
      }
    }
    // 申报流程
    .hllj_wrap {
      margin: 0 auto 2rem;
      ul {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        .hllj_items {
          flex-basis: 3.5rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          position: relative;
          &:not(:last-child)::after {
            position: absolute;
            content: "";
            display: block;
            width: 0.23rem;
            height: 0.3rem;
            top: 0.2rem;
            right: -0.11rem;
            background: url("../assets/arrow_right.png") no-repeat center center;
            background-size: 100%;
          }
          .item_img {
            width: 0.63rem;
            height: 0.68rem;
            img {
              width: 100%;
              height: auto;
            }
          }
          .item_name {
            font-size: 0.22rem;
            font-weight: 400;
            color: #F7D194;
            line-height: 1.2;
            margin: 0.17rem 0 0.11rem;
          }
          .item_time {
            font-size: 0.22rem;
            font-weight: normal;
            color: #F7D194;
            line-height: 1.2;
          }
        }
      }
    }
    .hllj {
      margin: 0 auto;
      margin-top: 0.52rem;
      //   width: 80%;
      //   height: 3.31rem;
      //   background: linear-gradient(93deg, rgba(35, 7, 9, 1), rgba(20, 2, 2, 1));
      //   box-shadow: 1px 0.14rem 0.07rem 0px rgba(24, 25, 26, 0.23);
      //   border-radius: 0.15rem;
      //   padding: 0.93rem 1.47rem;
      //   box-sizing: border-box;
      font-size: 0.68rem;
      text-align: center;
      color: rgba(248, 210, 148, 1);
      img {
        width: 100%;
      }
    }
  }
  .footer {
    img {
      width: 0.2rem;
      margin-right: 0.1rem;
    }
    p {
      width: 100%;
      font-size: 0.16rem;
      padding: 0.05rem;
    }
    a {
      color: #8f8f8f;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
    }
    position: absolute;
    left: 0;
    bottom: -2.3rem;
    width: 100%;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    padding: 0.5rem 0;
    color: #8f8f8f;
    font-size: 0.14rem;
    box-sizing: border-box;
    align-items: center;
    height: 2.55rem;
    background: rgba(40, 40, 40, 1);
    // border: 0.05rem solid rgba(4, 0, 1, 1);
    // box-sizing: content-box;
  }
  .dialog-title {
    margin-top: -1.2px * 100;
    font-size: 0.24px * 100;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(247, 209, 148, 1);
  }
  .dialog-content {
    padding-top: 0.5px * 100;
    box-sizing: border-box;
    text-align: left;

    .el-step__icon.is-text {
      width: 0.45px * 100;
      height: 0.45px * 100;
      background: #cdc8c0;
      border-radius: 0.27px * 100;
      border: 0.03px * 100 solid rgba(216, 178, 126, 0.1);
      .el-step__icon-inner {
        font-size: 0.24px * 100;
        font-family: FZHTK--GBK1-0, FZHTK--GBK1;
        font-weight: normal;
        color: rgba(255, 255, 255, 1);
      }
    }
    .form {
      .custom_style {
        .el-form-item__label {
          text-align: left !important;
        }
      }
      .el-form {
        // width: 80%;
      }
      .el-textarea__inner {
        width: 5.2px * 100;
      }
      display: flex;
      justify-content: center;
      margin-top: 0.2px * 100;
      .logo_upload_wrap {
        width: 5.2px * 100;
        border: 1px solid #dcdfe6;
        min-height: 0.8px * 100;
        height: auto;
        border-radius: 0.04px * 100;
        padding: 0.1px * 100 0.15px * 100;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;

        .avatar-uploader-logo {
          width: 100%;
          min-height: 0.6px * 100;
          height: auto;
          padding: 0.05px * 100 0;
          box-sizing: border-box;
          .el-progress {
            width: 0.6px * 100 !important;
            height: 0.6px * 100 !important;
          }
          .el-upload {
            display: flex;
            align-items: center;

            span {
              width: 4.25px * 100;
              line-height: 1.5;
              padding: 0 0.13px * 100;
              box-sizing: border-box;
              text-align: left;
              font-size: 0.14px * 100;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(144, 147, 153, 1);
            }
          }
          .avatar-uploader-icon {
            width: 0.6px * 100;
            height: 0.6px * 100;
            font-size: 0.3px * 100;
            display: flex;
            justify-content: center;
            align-items: center;
            background: rgba(220, 223, 230, 0.3);
            border-radius: 0.02px * 100;
          }
        }
      }
      .avatar-uploader {
        width: 5.2px * 100;
        border: 1px solid #dcdfe6;
        min-height: 0.8px * 100;
        height: auto;
        border-radius: 0.04px * 100;
        padding: 0.1px * 100 0.15px * 100;
        box-sizing: border-box;
        .el-progress {
          width: 0.6px * 100 !important;
          height: 0.6px * 100 !important;
        }
        .el-upload {
          display: flex;
          align-items: center;

          span {
            width: 4.25px * 100;
            line-height: 1.5;
            padding: 0 0.13px * 100;
            box-sizing: border-box;
            text-align: left;
            font-size: 0.14px * 100;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(144, 147, 153, 1);
          }
        }
        .avatar-uploader-icon {
          width: 0.6px * 100;
          height: 0.6px * 100;
          font-size: 0.3px * 100;
          display: flex;
          justify-content: center;
          align-items: center;
          background: rgba(220, 223, 230, 0.3);
          border-radius: 0.02px * 100;
        }
      }
      .textarea {
        width: 5.2px * 100;
        .el-textarea__inner {
          height: 1.5px * 100;
          font-size: 0.14px * 100;
          padding: 5px 40px 5px 15px !important;
          font-family: PingFangSC-Regular, PingFang SC;
          border-radius: 0.04px * 100;
          &::-webkit-input-placeholder {
            color: #909399;
          }
        }
        &_work {
          .el-textarea__inner {
            height: 2.5px * 100;
            font-size: 0.14px * 100;
            padding: 5px 40px 5px 15px !important;
            font-family: PingFangSC-Regular, PingFang SC;
            border-radius: 0.04px * 100;
            &::-webkit-input-placeholder {
              color: #909399;
            }
          }
        }
      }
      .el-form-item__error {
        top: 30%;
        right: -2.02px * 100;
        left: auto;
        width: 2px * 100;
        text-align: left;
      }
      .el-form-item {
        margin-bottom: 0.12px * 100;
        .el-form-item__label {
          text-align: right;
          font-size: 0.16px * 100;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(57, 72, 89, 1);
        }
      }
      .el-input__inner {
        width: 5.2px * 100;
        height: 0.4px * 100;
        display: flex;
        align-items: center;
        line-height: auto !important;
        font-size: 0.14px * 100;
        font-family: PingFangSC-Regular, PingFang SC;
        border-radius: 0.04px * 100;
        border: 1px solid rgba(220, 223, 230, 1);
        &::-webkit-input-placeholder {
          color: #909399;
        }
      }
    }
    .footer-form {
      margin-top: 0.3px * 100;
      display: flex;
      justify-content: center;
      .el-button {
        width: 1.56px * 100;
        height: 0.42px * 100;
        background: rgba(216, 178, 126, 1);
        border-radius: 0.04px * 100;
        border: none;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
      }
    }
  }
}
.el-step__head.is-success {
  border-color: #d8b27e;
}
.el-step__line {
  top: 49% !important;
  left: 60% !important;
  right: -40% !important;
  background-color: rgba(235, 238, 245, 1) !important;
}
.el-step__title {
  margin-top: 0.18px * 100;
  font-size: 0.18px * 100;
  font-family: FZHTK--GBK1-0, FZHTK--GBK1;
  font-weight: normal;
  color: rgba(57, 72, 89, 1);
  line-height: 0.2px * 100;
}
.is-process {
  .el-step__icon.is-text {
    background: rgba(216, 178, 126, 1) !important;
  }
}
.sbjj {
  margin-left: 240px;
  width: 5.2px * 100;
  background: rgba(220, 223, 230, 0.25);
  padding: 0.1px * 100 0.2px * 100;
  box-sizing: border-box;
  line-height: 1.5;
  margin-bottom: 0.12px * 100;
  p {
    margin-top: 0.1px * 100;
  }
}
.is-success {
  color: #000 !important;
  font-weight: 700;
}
.picture-card {
  .el-progress {
    width: 0.6px * 100 !important;
    height: 0.6px * 100 !important;
  }
  .is-success,
  .el-upload-list__item-actions {
    width: 0.6px * 100 !important;
    height: 0.6px * 100 !important;
  }
  .el-upload-list__item {
    width: 0.6px * 100 !important;
    height: 0.6px * 100 !important;
  }
  .el-progress-circle {
    width: 0.6px * 100 !important;
    height: 0.6px * 100 !important;
  }
  .el-form-item__content {
    width: 5.2px * 100;
    min-height: 1.04px * 100;
    height: auto !important;
    border-radius: 0.04px * 100;
    border: 1px solid rgba(220, 223, 230, 1);
    padding: 0.1px * 100 0.15px * 100;
    box-sizing: border-box;
    .el-upload--picture-card {
      width: 0.6px * 100;
      height: 0.6px * 100;
      line-height: 0.7px * 100;
    }
    .card {
      font-size: 0.14px * 100;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(144, 147, 153, 1);
      line-height: 0.14px * 100;
    }
  }
}

.footer-tips {
  font-size: 14px;
  color: #F56C6C;
  text-align: center;
  line-height: 18px;
  margin: 10px 0;
}

.footer-active {
  font-size: 0.19px * 100;
  color: rgba(57, 72, 89, 1);
  line-height: 0.19px * 100;
  text-align: center;
  margin-top: 0.2px * 100;
  span {
    display: inline-block;
    font-size: 0.19px * 100;
    color: rgba(216, 178, 126, 1);
    &:hover {
      font-weight: 500;
      text-decoration: underline;
      cursor: pointer;
    }
  }
  
}
.avatar {
  width: 0.6px * 100 !important;
  height: 0.6px * 100 !important;
}
.addform {
  text-align: center;
  font-size: 0.16px * 100;
  font-family: PingFangSC-Regular, PingFang SC;
  color: rgba(216, 178, 126, 1);
  cursor: pointer;
  img {
    width: 0.16px * 100;
    margin-right: 0.05px * 100;
    margin-bottom: 0.03px * 100;
  }
  span {
    margin-left: 0.05px * 100;
    font-size: 0.12px * 100;
    font-family: PingFangSC-Regular, PingFang SC;
    color: rgba(144, 147, 153, 1);
    display: inline-block;
  }
}
.el-progress-circle {
  width: 0.6px * 100 !important;
  height: 0.6px * 100 !important;
}
.el-select-group__title {
  height: 22px;
  background: rgba(216, 178, 126, 0.1);
  border-radius: 2px;

  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #d8b27e;
  display: flex;
  align-items: center;
}
.el-select-group__wrap:not(:last-of-type) {
  padding-bottom: 0;
}
.el-select-group__wrap:not(:last-of-type)::after {
  display: none !important;
}
.el-upload-dragger {
  width: 100%;
  height: 150px!important;
}
.el-upload {
  width: 100%;
}

.ivu-tabs-nav-scroll {
  display: flex;
  justify-content: center;
}
.ivu-tabs-bar {
  border: none !important;
}
.ivu-tabs-nav-container {
  height: 100% !important;
}
.ivu-tabs-nav {
  font-weight: 600;
  border: 2px solid #CCA56B !important;
  background: transparent !important;
  font-size: 0.26rem;
  color: #CCA56B !important;
  border-radius: 0.1rem;
}
.ivu-tabs-ink-bar {
  height: 0 !important;
}
.ivu-tabs-tab {
  height: 100% !important;
  margin-right: 0 !important;
  border: none !important;
  border-radius: 0.06rem !important;
  background: transparent !important;
  padding: 0.1rem 0.4rem !important;
  line-height: 1.2 !important;
}

.ivu-tabs-tab:hover {
  color: #CCA56B !important;
}

.ivu-tabs-tab-active {
  border: none !important;
  background: #CCA56B !important;
  border-radius: 0.06rem !important;
  color: #000 !important;
  margin-right: 0;
  padding: 0.1rem 0.4rem !important;
  line-height: 1.2 !important;
}
.ivu-tabs-tab-active:hover {
  color: #000 !important;
}
.el-upload__tip {
  margin-top: -7px !important;
}
.el-upload-dragger {
  height: 120px;
}
.el-upload-dragger .el-icon-upload {
  height: 0px !important;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}
.el-upload-dragger {
  width: 520px !important;
}

/* 案例收录授权弹窗（append-to-body 后 wrapper 挂在 body 下，恢复默认半透明遮罩） */
body > .el-dialog__wrapper {
  background: transparent;
}
.agree-case-dialog {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(57, 72, 89, 0.28);
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 0;
  }
}
.agree-case {
  padding: 40px 40px 36px;
  text-align: center;
  background: linear-gradient(180deg, #faf3e7 0%, #ffffff 42%);

  &__icon {
    width: 64px;
    height: 64px;
    margin: 0 auto 16px;
    border-radius: 50%;
    background: linear-gradient(135deg, #d8b27e 0%, #f7d194 100%);
    box-shadow: 0 6px 16px rgba(216, 178, 126, 0.35);
    display: flex;
    align-items: center;
    justify-content: center;
    i {
      font-size: 32px;
      color: #fff;
    }
  }

  &__title {
    font-size: 20px;
    font-weight: 600;
    color: #333;
    margin-bottom: 14px;
  }

  &__desc {
    max-width: 290px;
    margin: 0 auto 28px;
    font-size: 14px;
    line-height: 1.8;
    color: #666;
    text-align: left;
  }

  &__book {
    color: #e02020;
    font-weight: 600;
  }

  &__btns {
    display: flex;
    justify-content: center;
    .el-button + .el-button {
      margin-left: 24px;
    }
  }

  &__btn {
    min-width: 120px;
    height: 40px;
    border-radius: 20px;
    font-size: 15px;
    cursor: pointer;
    transition: all 0.2s ease-in-out;

    i {
      margin-right: 4px;
    }
  }

  &__btn_yes {
    background: rgba(216, 178, 126, 0.8);
    border: none;
    color: #fff;
    &:hover,
    &:focus {
      background: #d8b27e;
      color: #fff;
    }
  }

  &__btn_no {
    background: #fff;
    border: 1px solid #d8b27e;
    color: #d8b27e;
    &:hover,
    &:focus {
      background: #faf5ec;
      border-color: #c9a26b;
      color: #c9a26b;
    }
  }
}
</style>